function addToFav(partNum) {
    return $.ajax({
        type: "post",
        url: base_index_url + "my_account/favourites/create",
        data: {"partNum": partNum}
    });
}

$(document).ready(function () {
    $("#wrapper").on("click", ".add-product-to-favourite", function() {
        var addFavourite = addToFav($(this).attr("data-part-num"));
        $(this).addClass("is-favourite");
        
        addFavourite.done(function (response) {
            Notifications.success(response.message);
        }).fail(function (jqXHR, textStatus, errorThrown) {
            Notifications.fail(jqXHR.responseText);
        });
    });
});

$(document).ready(function(){
    if($('#billing_country').length > 0) {
        $('#billing_country').data('type', 'billing');
        $('#billing_country').on("change", function() {
            if($(this).val() != '') {
                build_regions_list($(this).val(), $(this).data('type'));
            } else {
                $('#' + $(this).data('type') + '_country_division').html('');
            }
        });
    }

    if($('#shipping_country').length > 0) {
        $('#shipping_country').data('type', 'shipping');
        $('#shipping_country').on("change", function() {
            if($(this).val() != '') {
                build_regions_list($(this).val(), $(this).data('type'));
            } else {
                $('#' + $(this).data('type') + '_country_division').html('');
            }
        });
    }
});

function build_regions_list(countryCode, countryType) {
    var countryDivision = $("#" + countryType + "_country_division");

    $('.' + countryType + '_country_division_loader').show();

    $.ajax({
        url: base_index_url + 'places/country/' + countryCode + '/regions',
        success: function( data ) {
            try {
                countryDivision.html('');
                countryDivision.append('<option value=""></option>');

                $.each(data, function(index, region){
                    countryDivision.append('<option value="' + region.code + '" >' + region.name + '</option>');
                });

                $('#' + countryType + '_country_division >option:eq(0)').attr('selected', 'selected');
            } catch(e) {
                alert('Problem parsing data from server. Your changes have not been saved');
            }
        },
        complete: function(data) {
            $("#" + countryType + "_country_division").trigger("change");
            $("#" + countryType + "_country_division").focus();
            $('.' + countryType + '_country_division' + '_loader').hide();
        }
    });
}

/* MASK VALIDATION */
function only_numbers(event) {
    /* 0-9 or numpad 0-9, disallow shift, ctrl, and alt */
    if ((!event.shiftKey && !event.ctrlKey && !event.altKey) && ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105))) {
        /* check textbox value now and tab over if necessary */
    } else if (event.keyCode != 9 && event.keyCode != 8 && event.keyCode != 13 && event.keyCode != 46 && event.keyCode != 37 && event.keyCode != 39) { /* not esc, del, left, right or enter */
        event.preventDefault();
    } /* else the key should be handled normally */
}

/* MASK VALIDATION */
function alphanumeric(event) {
    if (
        /* 0-9 and a-z and numpad 0-9, disallow shift, ctrl, and alt */
        (
            ((!event.shiftKey && !event.ctrlKey && !event.altKey) && ((event.keyCode >= 48 && event.keyCode <= 90) || (event.keyCode >= 96 && event.keyCode <= 105))) ||
            /* A-Z characters */
            ((event.shiftKey) && (event.keyCode >= 65 && event.keyCode <= 90)) ||
            /* allow enter key as it may be needed for form submission */
            (event.keyCode = 13)
        )
       )            {
        /* check textbox value now and tab over if necessary */
    } else if (event.keyCode != 9 && event.keyCode != 8 && event.keyCode != 46 && event.keyCode != 37 && event.keyCode != 39) { /* not esc, del, left or right */
        event.preventDefault();
    } /* else the key should be handled normally */
}

function isInteger(qty) {
    return ((!isNaN(qty)) && (isFinite(qty))) ? true : false;
}

function isValidQty(qty) {
    return (isInteger(qty) && (qty > 0) && (qty <= maximumQuantityLimitForCart)) ? true : false;
}

function isValidEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test($.trim(email));
}

function isAlphanumericDashUnderscore(string)
{
    var regex = new RegExp("^[a-zA-Z0-9-_]+$");

    return (regex.test(string.trim())) ? true : false;
}

$(document).ready(function() {
    $("#wrapper").on("click", "button.show-warehouses-stock-btn", function(e) {
        var $this = $(this);

        var partNum = $this.attr('data-part-num');
        var warehouse = $this.attr('data-warehouse');
        var warehousePartnum = warehouse + '-' + partNum;

        $("div.stock-indicator-warehouse-grid").each(function(index) {
            var element = $(this);
            var elementWarehousePartnum = element.attr('data-warehouse') + '-' + element.attr('data-part-num');

            if(elementWarehousePartnum != warehousePartnum) {
                element.hide();
            }
        });

        $this.next().toggle();
    });

    $("#wrapper").on("click", "button.ws-close", function(e) {
        $(this).parent().hide();
    });
});
function addProductToCompare(part, warehouse) {
    var addProduct = processCompareRequest("add", part, warehouse);

    addProduct.then(
        function(results) {
            updateCompareLinkWidget(results);
            setCompareCheckBox(true, part, warehouse, "");
            setViewAllComparisonsLink(results.url, results.count);
        },
        function(jqXHR, textStatus, errorThrown) {
            setCompareCheckBox(false, part, warehouse, jqXHR.responseText);
        }
    );
}

function removeProductToCompare(part, warehouse) {
    var removeProduct = processCompareRequest("remove", part, warehouse);

    removeProduct.then(
        function(results) {
            updateCompareLinkWidget(results);
            setCompareCheckBox(false, part, warehouse, "");
            setViewAllComparisonsLink(results.url, results.count);
            removeProductFromCompareTableView(part, warehouse, results.count);
            updateCompareUrl(results);
        },
        function(jqXHR, textStatus, errorThrown) {
        }
    );
}

function processCompareRequest(action, part, warehouse) {
    return $.ajax({
            url:  base_index_url + "compare/" + action,
            type:"POST",
            data:{
                "part" : part,
                "warehouse" : warehouse
            },
            dataType:"json"
        }).promise();
}

function updateCompareLinkWidget(data) {
    buildCompareLinkWidget(data.url, data.products, data.count);
}

function buildCompareLinkWidget(link, products, count) {
    var compareLinkWidgetTemplate = $('#compare_link_widget_template');

    if(compareLinkWidgetTemplate.length > 0) {
        compareLinkElement        = $('.widget.compare_link');
        compareLinkWidgetTemplateHtml = _.template(compareLinkWidgetTemplate.html());

        compareLinkElement.html(compareLinkWidgetTemplateHtml({
            compareLink          : link,
            sessionProducts      : products,
            sessionProductsCount : count
        }));
    }
}

function setCompareCheckBox(action, part, warehouse, message) {
    removeAllCompareMessages();

    var element = $('.add_to_compare input.compare-this[data-part="' + part + '"][data-warehouse="' + warehouse + '"]');

    if (action) {
        element.attr('checked','checked').attr('data-original-title', "");
    } else {
        element.removeAttr('checked').attr('data-original-title', message).trigger('mouseover');
    }
}

function removeAllCompareMessages() {
    $('input.compare-this').attr('data-original-title', '');
}

function setViewAllComparisonsLink(url, count) {
    var element = $("a.view_all_comparisons_link");
    element.attr("href", url);
}

function removeProductFromCompareTableView(part, warehouse, count) {
    var table = $('table.product_compare_table');

    if(table.length > 0) {
        table.find('tr > td[data-part="' + part + '"][data-warehouse="' + warehouse + '"]').remove();
    }

    if(count == 0) {
        $('.no_products_for_comparison').show();
        table.remove();
    }
}

function updateCompareUrl(results) {
    var title = window.document.title;
    window.history.replaceState(title, title, results.url);
}

function getCompareProducts() {
    $.ajax({
        url :  base_index_url + "compare/show",
        type : "GET",
        dataType : "json",
        success : function(data) {
            updateCompareLinkWidget(data);
        }
    });
}

$(document).ready(function () {
    $("#wrapper").on("change", "input.compare-this", function () {
        var $this = $(this);
        var part = $this.attr('data-part');
        var warehouse = $this.attr('data-warehouse');
        var checked = $this.is(':checked');

        if (checked) {
            addProductToCompare(part, warehouse);
        } else {
            removeProductToCompare(part, warehouse);
        }
    });

    $("#wrapper").on("click", "button.remove_compare_product", function () {
        var $this = $(this);
        var part = $this.attr('data-part');
        var warehouse = $this.attr('data-warehouse');

        removeProductToCompare(part, warehouse);
    });
});

$(document).ready(function () {
    ajaxCart = new zsAjaxCart(zsAjaxCartConfig);
    ajaxQuote = new zsAjaxQuote(zsAjaxCartConfig);

    $("body").on("keydown", "input.qty", only_numbers);

    $("body").on("click", "button.add_to_cart", function (e) {
        e.preventDefault();
        ajaxCart.addSingleProduct($(this).closest("form"));
    });

    $("body").on("click", "button.multi-add-to-cart", function (e) {
        e.preventDefault();
        ajaxCart.addMultipleProducts($(this));
    });

    $("body").on("click", ".browse_paginator a", function (e) {
        if (!ajaxCart.checkBeforeChangingPage()) {
            e.preventDefault();
        }
    });

    $("body").on("click", ".add-notes-quote", function (e) {
        e.preventDefault();
        ajaxQuote.addOrderNotes($(this).parent().parent().parent());
    });

    $("body").on("click", ".add-addons", function (e) {
        e.preventDefault();
        ajaxCart.validateAndAddProductsAndAddons($(this).parent().parent().parent());
    });

    $("body").on("click", "button.add_to_quote", function (e) {
        e.preventDefault();
        ajaxQuote.addSingleProduct($(this).closest("form"));
    });
});

function zsAjaxCart(config) {
    this.cart = null;
    this.products = [];
    this.messages = config.responses;
    this.settings = config.settings.cart;
    this.button_multi_add_to_cart = $('button.multi-add-to-cart');
    this.category_table_view = ($('.category-table-view').length > 0) ? true : false;
    this.added_errors = $('.added-error');
    this.multiAddToCartGroup = "";
    this.quickEntryForm = $("#quick-entry-form");
    this.cartController = $("#cart-controller");
    this.settings.addons = config.settings.addons;
}

zsAjaxCart.prototype.addSingleProduct = function (form) {
    var self = this;
    var qty_info = form.children('div.qty_info');

    self.qty = Number(qty_info.find('input.qty').val());
    self.uom = qty_info.find('select.uom_select').val() || qty_info.find('.uom').html();
    self.btn_add_to_cart = qty_info.find('button.add_to_cart');
    self.part_num = self.btn_add_to_cart.attr('data-part-num');
    self.slug = self.btn_add_to_cart.attr('data-slug') || "";
    self.warehouse_id = self.btn_add_to_cart.attr('data-warehouse');
    self.comments = self.getProductComments(self.slug);
    self.configuration = self.btn_add_to_cart.attr('data-configuration');
    self.customImage = self.btn_add_to_cart.attr('data-customImage');
    self.equipmentRegistryId = self.btn_add_to_cart.attr('data-equipment-registry-id');

    self.products = [];
    self.addons = {};


    isAddonsControllerAvailable = !_.isUndefined(angular.element("#product-addon-controller").scope());
    if (isAddonsControllerAvailable) {
        this.addonsApp = angular.element("#product-addon-controller").scope().paCtrl;
    }

    if (isValidQty(self.qty) && isAddonsControllerAvailable && this.addonsApp.hasAddons(self.slug)) {
        Notifications.closeAll();
        this.addonsApp.showModal();
        this.addonsApp.setIsAddToCart();
    } else if (isValidQty(self.qty)) {
        var product = self.getProductStub();

        product.warehouse_id = self.warehouse_id;
        product.part_num = self.part_num;
        product.slug = self.slug;
        product.uom = self.uom;
        product.qty = self.qty;
        product.comments = self.comments;
        product.configuration = self.getProductConfiguration(self.configuration);
        product.customImage = self.customImage;
        product.equipmentRegistryId = self.equipmentRegistryId;

        self.addToProductsArray(product);
        self.submitProductsToAdd(self.btn_add_to_cart);
    } else {
        Notifications.warning(self.messages.invalid_qty);
    }
};

zsAjaxCart.prototype.addProductConfiguratorProduct = function (data, button) {
    var self = this;
    var product = self.getProductStub();

    product.warehouse_id = data.warehouse_id;
    product.part_num = data.part_num;
    product.slug = data.slug;
    product.uom = data.uom;
    product.qty = data.qty;
    product.comments = data.comments;
    product.configuration = self.getProductConfiguration(data.configuration);
    product.customImage = data.customImage;

    self.addToProductsArray(product);
    self.submitProductsToAdd(button);
};

zsAjaxCart.prototype.getProductComments = function (slug) {
    var commentsField = $('#comments_' + slug);

    return commentsField.length ? commentsField.val() : "";
};

zsAjaxCart.prototype.validateAndAddProductsAndAddons = function (container) {
    var self = this;

    this.addonsApp.completeWizard();

    _.forEach(this.addonsApp.stepChoices, function (addon) {
        if (self.validateAddonForCart(addon)) {
            self.addToProductAddonsArray(
                self.slug,
                addon.warehouseId,
                addon.partNum,
                addon.slug,
                addon.unitOfMeasure,
                self.qty,
                addon.comments,
                addon.nonStockProduct,
                addon.price.amount,
                addon.description.short
            );
        }
    });

    var product = self.getProductStub();
    var addonNotes = this.addonsApp.getNotes();

    product.warehouse_id = self.warehouse_id;
    product.part_num = self.part_num;
    product.slug = self.slug;
    product.uom = self.uom;
    product.qty = self.qty;
    product.comments = !_.isEmpty(addonNotes) ? addonNotes : self.comments;

    self.addToProductsArray(product);
    self.submitProductsToAdd(self.btn_add_to_cart);
    this.addonsApp.resetStepper();
};

zsAjaxCart.prototype.validateAddonForCart = function (addon) {
    return _.isNull(addon) ? false : true;
};

zsAjaxCart.prototype.addToProductAddonsArray = function (parentProductSlug, warehouse, part_num, slug, uom, qty, comments, isNonStock, price, description) {
    var self = this;

    if (!self.addons[parentProductSlug]) {
        self.addons[parentProductSlug] = [];
    }

    var product = self.getProductStub();

    product.warehouse_id = warehouse;
    product.part_num = part_num;
    product.slug = slug;
    product.uom = uom;
    product.qty = qty;
    product.comments = comments;
    product.is_non_stock = isNonStock;
    product.price = price;
    product.short_description = description;
    product.parentProductSlug = parentProductSlug;

    self.addons[parentProductSlug].push(product);
};

zsAjaxCart.prototype.addErrorMessage = function(addon) {
    $(addon.commentsField).css("border-color", "red");
};

zsAjaxCart.prototype.addToProductsArray = function (product) {
    var self = this;

    self.products.push(product);
};

zsAjaxCart.prototype.getProductStub = function () {
    return {
        warehouse_id: null,
        part_num: null,
        slug: null,
        uom: null,
        qty: null,
        comments: "",
        is_non_stock: 0,
        custom_data: null,
        price: null,
        short_description: null,
        parentProductSlug: null,
        equipmentRegistryId: 0,
        configuration: null,
        customImage: ""
    };
};

zsAjaxCart.prototype.getProductConfiguration = function (configuration) {
    if (configuration) {
        return JSON.parse(configuration);
    }
};

zsAjaxCart.prototype.addMultipleProducts = function (element) {
    var self = this;

    self.products = [];
    self.addons = {};
    self.multiAddToCartGroup = element.data("group");

    $(".product_preview." + self.multiAddToCartGroup).each(function () {
        var $this = $(this);

        var qty_info = $this.find('div.qty_info');
        var qty = Number(qty_info.find('input.qty').val());
        var uom = qty_info.find('select.uom_select').val();
        var btn_add_to_cart = qty_info.find('button.add_to_cart');
        var is_quote_only = (btn_add_to_cart.length === 0) ? true : false;
        var part_num = btn_add_to_cart.attr('data-part-num');
        var slug = btn_add_to_cart.attr('data-slug') || "";
        var warehouse = btn_add_to_cart.attr('data-warehouse');
        var configuration = btn_add_to_cart.attr('data-configuration');
        var customImage = btn_add_to_cart.attr('data-customImage');
        var commentsField = $('textarea.comments', $this);
        var comments = commentsField.length ? commentsField.val() : "";
        var equipmentRegistryId = btn_add_to_cart.attr('data-equipment-registry-id');

        if (qty !== 0 && part_num !== undefined) {
            if (!is_quote_only) {
                var product = self.getProductStub();

                product.warehouse_id = warehouse;
                product.part_num = part_num;
                product.slug = slug;
                product.uom = uom;
                product.qty = qty;
                product.configuration = self.getProductConfiguration(configuration);
                product.customImage = customImage;
                product.comments = self.getProductComments(slug);
                product.equipmentRegistryId = equipmentRegistryId;

                self.addToProductsArray(product);
            }
        }
    });

    if (self.products.length > 0) {
        self.submitProductsToAdd(element);
    }
};

zsAjaxCart.prototype.submitProductsToAdd = function (button) {
    var self = this;
    var curr_text = button.html();

    self.error_count = 0;

    if (!_.isUndefined(self.preProductsAddHook) && typeof(self.preProductsAddHook) === "function") {
        self.preProductsAddHook(button, curr_text);
    } else {
        self.process(button, curr_text);
    }
};

zsAjaxCart.prototype.process = function (button, curr_text) {
    var self = this;

    if (!_.isEmpty(self.addons)) {
        self.mergeProductsAndAddons();
    }

    var productsAdded = self.addProducts(self.products);

    button.html(self.messages.adding).attr('disabled', true);

    productsAdded.done(function (data) {
        self.showProductsAddedResponse(data.message);
        self.renderCartOrAddToCartMessages(data);
        button.html(curr_text).attr('disabled', false);
        button.find(".waves-ripple").remove();
        self.resetQuickEntryForm();
        self.resetInputs(button);
        self.products = [];
        self.addons = {};
    });
};

zsAjaxCart.prototype.resetInputs = function(button) {
    var self = this;

    if (self.settings.resetQuantityAfterAddToCart) {
        var container = $(button).parent();
        var addToCart = container.find("button.add_to_cart");
        var defaultQuantity = addToCart.attr("data-default-qty");

        container.find("input.qty").val(defaultQuantity);
    }

    self.resetMultiAddInputs(button);
};

zsAjaxCart.prototype.resetMultiAddInputs = function (button) {
    $(".product_preview." + button.data("group")).each(function () {
        var self = $(this);

        var container = self.find("div.qty_info");
        var addToCart = container.find("button.add_to_cart");
        var defaultQuantity = addToCart.attr("data-default-qty");

        $(container).find("input").val(defaultQuantity);
    });
};

zsAjaxCart.prototype.mergeProductsAndAddons = function () {
    var self = this;

     _.forEach(self.addons[self.slug], function (addon) {
        self.products.push(addon);
     });
};

zsAjaxCart.prototype.addProducts = function (products) {
    return $.ajax({
        url: base_index_url + "cart/add",
        type: "POST",
        data: {"products": products},
        dataType: "json"
    });
};

zsAjaxCart.prototype.showProductsAddedResponse = function (products) {
    var self = this;

    $.each(products, function () {
        var input_qty = $('input#qty_' + this.slug);

        if (this.success) {
            if ($('.widget.product_list.list').length || $('.category-table-view').length) {
                input_qty.attr('value', '');
            }

            if (self.settings.addProductsIndividually) {
                $('textarea.comments', this).val("");
            } else {
                if (this.slug in window.productComments) {
                    window.productComments[this.slug][this.uom] = this.comment;
                }
            }
        } else {
            ++self.error_count;
        }
    });
};

zsAjaxCart.prototype.renderCartOrAddToCartMessages = function (data) {
    var self = this;

    if (this.settings.useMiniCart) {
        cartController.reload(data);

        if (this.settings.afterAddToCartShowCart) {
            cartController.show();
        }
    } else {
        var cartApp = angular.element(this.cartController).scope();

        if (_.isUndefined(cartApp)) {
            location.reload();
        }

        cartApp.$apply(function () {
            cartApp.cartCtrl.details = data.cartDetails;
            cartApp.cartCtrl.addedProducts = data.message;

            cartApp.cartCtrl.afterAddingToCartAction();
        });
    }

    if (!this.settings.afterAddToCartShowCart || !self.containsSuccessFullAdd(data.message)) {
        Notifications.addToCart(data.message);
    }
};

zsAjaxCart.prototype.containsSuccessFullAdd = function (products) {
    return _.size(products) !== _.size(_.filter(products, {"success": false}));
};

zsAjaxCart.prototype.resetQuickEntryForm = function () {
    var self = this;

    if (self.quickEntryForm.length) {
        var quickEntryCriteria = $("#quick-entry-criteria");

        if (!_.isEmpty(quickEntryCriteria.val())) {
            quickEntryCriteria.val("").focus();
            $("#quick-entry-uoms").html("");
            $("#quick-entry-qty").val(1);
        }
    }
};

zsAjaxCart.prototype.checkBeforeChangingPage = function () {
    var self = this;
    var qtys_exist = false;
    var result = true;

    if (self.button_multi_add_to_cart.is(':visible')) {
        $.each($('input.qty'), function () {
            if ($(this).val() !== '') {
                qtys_exist = true;
            }
        });

        if (qtys_exist) {
            result = confirm(self.messages.page_change);
        }
    }

    return result;
};

function zsAjaxQuote(config) {
    this.cart = null;
    this.settings = config.settings.quote;
    this.products = [];
    this.messages = config.responses;
    this.quote_preview_sidebar = $('div#sidebar_quote_preview');
    this.quote_preview_topbar = $('div#quote_preview');
    this.button_add_to_cart = $('button.add_to_quote');
    this.button_multi_add_to_quote = $('button.multi-add-to-quote');
}

zsAjaxQuote.prototype.addSingleProduct = function (form) {
    var self = this;

    self.qty_info = form.children('div.qty_info');
    self.qty = self.qty_info.find('input.qty').val();
    self.uom = self.qty_info.find('select.uom_select').val();
    self.btn_add_to_quote = self.qty_info.find('button.add_to_quote');
    self.part_num = self.btn_add_to_quote.attr('data-part-num');
    self.slug = self.btn_add_to_quote.attr('data-slug') || "";
    self.warehouse = self.btn_add_to_quote.attr('data-warehouse');

    var commentsField = $('textarea.comments', form);
    self.comments = commentsField.length ? commentsField.val() : "";

    self.products = [];

    var isAddonsControllerAvailable = !_.isUndefined(angular.element("#product-addon-controller").scope());
    if (isAddonsControllerAvailable) {
        self.addonsApp = angular.element("#product-addon-controller").scope().paCtrl;
    }

    if (isValidQty(self.qty) && isAddonsControllerAvailable && this.addonsApp.hasAddons(self.slug)) {
        Notifications.closeAll();
        this.addonsApp.showModal();
    } else if (isValidQty(self.qty)) {
        self.products.push({
            warehouse: self.warehouse,
            part_num: self.part_num,
            uom: self.uom,
            qty: self.qty,
            comments: self.comments
        });

        self.submitProductsToAdd(self.btn_add_to_quote);
    } else {
        Notifications.warning(self.messages.invalid_qty);
    }
};

zsAjaxQuote.prototype.addOrderNotes = function (form) {
    var self = this;

    self.addonsApp.completeWizard();
    var addonNotes = self.addonsApp.getNotes();

    self.products.push({
        warehouse: self.warehouse,
        part_num: self.part_num,
        uom: self.uom,
        qty: self.qty,
        comments: !_.isEmpty(addonNotes) ? addonNotes : self.comments
    });

    self.addonsApp.resetStepper();
    self.submitProductsToAdd(self.btn_add_to_quote);
};

zsAjaxQuote.prototype.addProductConfiguratorProduct = function (data, button) {
    var self = this;

    self.products = [];

    if (isValidQty(data.qty)) {
        self.products.push({
            warehouse: data.warehouse,
            part_num: data.part_num,
            slug: data.slug,
            uom: data.uom,
            qty: data.qty,
            comments: data.comments,
            configuration: JSON.parse(data.configuration),
            customImage: data.customImage,
            isConfiguredItem: true
        });

        self.submitProductsToAdd(button);
    } else {
        Notifications.warning(self.messages.invalid_qty);
    }
};

zsAjaxQuote.prototype.submitProductsToAdd = function (button) {
    var self = this;
    var curr_width = button.outerWidth();
    var curr_text = button.html();
    self.error_count = 0;

    $.ajax({
        url: base_index_url + "quote/add",
        type: "POST",
        data: {
            "products": this.products
        },
        dataType: "json",
        beforeSend: function () {
            button.html(self.messages.adding).attr('disabled', true).outerWidth(curr_width);
            if (self.hook_beforeQuoteAdd !== undefined) self.hook_beforeQuoteAdd();
        },
        success: function (data) {
            self.showProductsAddedResponse(data.products);
            self.updateQuotePreviews(data.quote_cart);

            if (self.settings.afterAddToQuoteShowQuoteCart) {
                window.location.href = base_index_url + "quote";
            } else {
                Notifications.addToCart(data.products);
            }
        },
        error: function (e) {
            alert(e.responseText);
        },
        complete: function () {
            button.html(curr_text).attr('disabled', false).outerWidth("");
        }
    });
};

zsAjaxQuote.prototype.showProductsAddedResponse = function (products) {
    var self = this;

    $.each(products, function () {
        var input_qty = $('input#qty_' + this.slug);

        if (this.response === '') {
            input_qty.attr('value', '');

            if (this.slug in window.productComments) {
                window.productComments[this.slug][this.uom] = this.comment;
            }
        } else {
            ++self.error_count;
        }
    });
};

zsAjaxQuote.prototype.updateQuotePreviews = function (quote) {
    if (this.quote_preview_topbar.length) {
        buildQuotePreviewTopbar(quote);
    }

    if (this.quote_preview_sidebar.length) {
        buildQuotePreviewSidebar(quote);
    }
};

zsAjaxQuote.prototype.checkBeforeChangingPage = function () {
    var self = this;
    var qtys_exist = false;
    var result = true;

    if (self.button_multi_add_to_quote.is(':visible')) {
        $.each($('input.qty'), function () {
            if ($(this).val() !== '') {
                qtys_exist = true;
            }
        });

        if (qtys_exist) {
            result = confirm(self.messages.page_change);
        }
    }

    return result;
};

/*
 * Example usages:
 *
 * Modal window:
 *     zsMessages.loading("Adding to cart");// shows modal loading
 *     zsMessages.loading(false);//to kill
 *
 * Cursor Follower:
 *    zsMessages.cursor_follow("Please Wait...");//to turn on a cursor-following indicator with progress bar
 *    zsMessages.cursor_follow(false);///to kill
 *
 *Popup:
 *     zsMessages.popover({content:"Please Wait...", target:$(".qty:eq(2)").parent()});
 *
 *you can also use bootstrap popup arguments from here http://twitter.github.com/bootstrap/javascript.html#popovers  for example:
 *     zsMessages.popover({content:"Please Wait...", target:$(".qty:eq(2)").parent(), title:"Info", placement:"top"});
 *
 *     Longhand examples:
 *     zsMessages.create_message({type:"modal", content:"hi", callback:function(e){e.delay(2000).fadeTo(500, 0, function(){$(this).remove();})}});//Gently fades out the modal screen after 2 seconds, then removes it
 */


zsMessages = {
    _defaults: {
        target          : "body",
        message_type    : "modal",
        loading_message : "Loading",
        loading_image   : base_index_url + "/application/modules/core/assets/images/ajax_arrows.gif"
    },

    _messages:[],
    _types: {
        modal: {
            id: null,
            content: "",
            css_class: "zs-activity-indicator-modal",
            template: "<div id='[id]' class='[css_class]'><div class='overlay'></div><div class='inner'><img src='[loading_image]' class='loading_image'/><div class='message-content'>[content]</div></div></div>",
            is_singleton: true,
            create: function(a) {
                this.id = "zsm-message-"+new Date().getTime();
                this.content = a.content;
                var newcontent = this.template.replace("[content]", a.content).replace("[css_class]", this.css_class).replace("[id]", this.id).replace("[loading_image]", zsMessages._defaults.loading_image);
                a.target.append(newcontent);
                return ($("#"+this.id));
            },
            destroy: function(){
                $("#"+this.id).remove();
            }
        },
        cursor_follow: {
            id: null,
            content: "",
            css_class: "zs-activity-indicator-cursor-follow",
            template: "<div id='[id]' class='[css_class]'style='top:-7000px;left:-7000px;z-index:100000'>[content]<br/><div class='progress progress-striped active'>  <div class='bar progress-bar' style='width: 100%;'></div></div></div>",
            is_singleton: true,
            handler: function(e){
                $("#"+this.id).css({
                    left:  e.pageX +15,
                    top:  e.pageY
                });
            },
            create: function(a){
                var my = this;
                this.id = "zsm-message-"+new Date().getTime();
                this.content = a.content;
                var newcontent = this.template.replace("[content]", a.content).replace("[css_class]", this.css_class).replace("[id]", this.id);
                a.target.append(newcontent);
                $(document).bind('mousemove', function(e){
                    my.handler(e);
                });

                return ($("#"+this.id));
            },
            destroy: function(){
                $("#"+this.id).remove();
                $(document) .unbind('mousemove', this.handler);
            }
        },
        popover: {
            id: null,
            content: "",
            css_class: "zs-activity-indicator-popover",
            template: "<div id='[id]' class='[css_class]'></div>",
            is_singleton: false,
            handler: function(e){
                $("#"+this.id).css({
                    left:  e.pageX +15,
                    top:  e.pageY
                });
            },
            create: function(a) {
                var my = this;
                this.id = "zsm-message-"+new Date().getTime();
                this.content = a.content;
                var newcontent = this.template.replace("[css_class]", this.css_class).replace("[id]", this.id);
                a.target.append(newcontent);
                var p = $("#"+this.id);
                p.popover(a);
                p.popover('show');

                return p;
            },
            destroy: function() {
                $("#"+this.id).popover('hide').remove();
            }
        }
    },

    loading:function(content) {
        if (content == false) {
            this._destroy_singletons();
            return null;
        } else {
            if (content == undefined) {
                content = this._defaults.loading_message;
            }

            return this.create_message({
                content:content,
                target:$('body')
            });
        }
    },

    cursor_follow:function(content) {
        if (content == false) {
            this._destroy_singletons();
            return null;
        } else {
            if (content == undefined) {
                content = "";
            }

            return this.create_message({
                content:content,
                type:"cursor_follow"
            });
        }
    },

    popover:function(a) {
        return this.create_message(
            $.extend({
                type:"popover"
            }, a)
        );
    },

    create_message:function(a) {
        if(a.type == undefined) {
            a.type = this._defaults.message_type;
        }

        if (a.target == undefined) {
            a.target = $(this._defaults.target);
        }

        if (a.content == undefined) {
            a.content = "";
        }
        var m = $.extend({}, this._types[a.type]);
        var $obj = m.create(a);
        if (m.is_singleton == true) {
            this._destroy_singletons();
        }

        this._messages.push(m);
        if (a.callback != undefined) {
            a.callback($obj);
        }

        return $obj;
    },

    _destroy_singletons:function() {
        var new_messages = [];
        $.each(this._messages, function() {
            if (this.is_singleton == true) {
                this.destroy();
            } else {
                new_messages.push(this);
            }
        });

        this._messages = new_messages;
    },

    clear_all:function() {
        $.each(this._messages, function() {
            this.destroy();
        });

        this._messages = [];
    }
};
var Notifications = function ()
{
    var defaultOptions = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": true,
        "progressBar": false,
        "positionClass": "toast-bottom-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": 300,
        "hideDuration": 1000,
        "timeOut": 5000,
        "extendedTimeOut": 1000,
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut",
      };

    function showNotificationType(type, message, options)
    {
        toastr.options = _.merge(defaultOptions, options);

        if (!_.isUndefined(message.title)) {
            toastr[type](message.content, message.title);
        } else {
            toastr[type](message);
        }
    }

    function success(message)
    {
        showNotificationType("success", message);
    }

    function warning(message)
    {
        showNotificationType("warning", message);
    }

    function fail(message)
    {
        showNotificationType("error", message);
    }

    function info(message)
    {
        showNotificationType("info", message);
    }

    function loading(message)
    {
        showLoadingModal(message, false);
    }

    function persist(message)
    {
        showLoadingModal(message, true);
    }

    function showLoadingModal(message, disallowClose)
    {
        var options = {};

        if (disallowClose) {
            options = {
                keyboard: false,
                backdrop: "static"
            };
        }

        $("#loading-modal-message").html(message);
        $("#loading-modal").modal(options);
    }

    function addToCart(products)
    {
        closeLoading();

        _.forEach(products, function (product) {
            var type = "success";
            var productMessage = getProductMessage(product);
            var options = {};

            if (!product.success) {
                type = "error";
                options = {
                    "timeOut": 0,
                    "extendedTimeOut": 0
                };
            } else if (product.onBackorder) {
                type = "warning";
            }

            showNotificationType(type, productMessage, options);
        });
    }

    function getProductMessage(product)
    {
        return {
            "title": product.part_num + " - " + product.title,
            "content": product.response
        };
    }

    function closeAll()
    {
        toastr.clear();
    }

    function closeLoading()
    {
        var loadingModal = $("#loading-modal");

        if ((loadingModal.data("bs.modal") || {})._isShown) {
            loadingModal.modal('hide');
        }
    }

    return {
        addToCart: addToCart,
        success: success,
        warning: warning,
        fail: fail,
        info: info,
        loading: loading,
        persist: persist,
        closeAll: closeAll,
        closeLoading: closeLoading
    };
}();

!function(t,e){"function"==typeof define&&define.amd?define(e):"object"==typeof exports?module.exports=e(require,exports,module):t.Tether=e()}(this,function(t,e,o){"use strict";function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function n(t){var e=getComputedStyle(t)||{},o=e.position;if("fixed"===o)return t;for(var i=t;i=i.parentNode;){var n=void 0;try{n=getComputedStyle(i)}catch(r){}if("undefined"==typeof n||null===n)return i;var s=n,a=s.overflow,f=s.overflowX,h=s.overflowY;if(/(auto|scroll)/.test(a+h+f)&&("absolute"!==o||["relative","absolute","fixed"].indexOf(n.position)>=0))return i}return document.body}function r(t){var e=void 0;t===document?(e=document,t=document.documentElement):e=t.ownerDocument;var o=e.documentElement,i={},n=t.getBoundingClientRect();for(var r in n)i[r]=n[r];var s=x(e);return i.top-=s.top,i.left-=s.left,"undefined"==typeof i.width&&(i.width=document.body.scrollWidth-i.left-i.right),"undefined"==typeof i.height&&(i.height=document.body.scrollHeight-i.top-i.bottom),i.top=i.top-o.clientTop,i.left=i.left-o.clientLeft,i.right=e.body.clientWidth-i.width-i.left,i.bottom=e.body.clientHeight-i.height-i.top,i}function s(t){return t.offsetParent||document.documentElement}function a(){var t=document.createElement("div");t.style.width="100%",t.style.height="200px";var e=document.createElement("div");f(e.style,{position:"absolute",top:0,left:0,pointerEvents:"none",visibility:"hidden",width:"200px",height:"150px",overflow:"hidden"}),e.appendChild(t),document.body.appendChild(e);var o=t.offsetWidth;e.style.overflow="scroll";var i=t.offsetWidth;o===i&&(i=e.clientWidth),document.body.removeChild(e);var n=o-i;return{width:n,height:n}}function f(){var t=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],e=[];return Array.prototype.push.apply(e,arguments),e.slice(1).forEach(function(e){if(e)for(var o in e)({}).hasOwnProperty.call(e,o)&&(t[o]=e[o])}),t}function h(t,e){if("undefined"!=typeof t.classList)e.split(" ").forEach(function(e){e.trim()&&t.classList.remove(e)});else{var o=new RegExp("(^| )"+e.split(" ").join("|")+"( |$)","gi"),i=u(t).replace(o," ");p(t,i)}}function l(t,e){if("undefined"!=typeof t.classList)e.split(" ").forEach(function(e){e.trim()&&t.classList.add(e)});else{h(t,e);var o=u(t)+(" "+e);p(t,o)}}function d(t,e){if("undefined"!=typeof t.classList)return t.classList.contains(e);var o=u(t);return new RegExp("(^| )"+e+"( |$)","gi").test(o)}function u(t){return t.className instanceof SVGAnimatedString?t.className.baseVal:t.className}function p(t,e){t.setAttribute("class",e)}function c(t,e,o){o.forEach(function(o){-1===e.indexOf(o)&&d(t,o)&&h(t,o)}),e.forEach(function(e){d(t,e)||l(t,e)})}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function g(t,e){var o=arguments.length<=2||void 0===arguments[2]?1:arguments[2];return t+o>=e&&e>=t-o}function m(){return"undefined"!=typeof performance&&"undefined"!=typeof performance.now?performance.now():+new Date}function v(){for(var t={top:0,left:0},e=arguments.length,o=Array(e),i=0;e>i;i++)o[i]=arguments[i];return o.forEach(function(e){var o=e.top,i=e.left;"string"==typeof o&&(o=parseFloat(o,10)),"string"==typeof i&&(i=parseFloat(i,10)),t.top+=o,t.left+=i}),t}function y(t,e){return"string"==typeof t.left&&-1!==t.left.indexOf("%")&&(t.left=parseFloat(t.left,10)/100*e.width),"string"==typeof t.top&&-1!==t.top.indexOf("%")&&(t.top=parseFloat(t.top,10)/100*e.height),t}function b(t,e){return"scrollParent"===e?e=t.scrollParent:"window"===e&&(e=[pageXOffset,pageYOffset,innerWidth+pageXOffset,innerHeight+pageYOffset]),e===document&&(e=e.documentElement),"undefined"!=typeof e.nodeType&&!function(){var t=r(e),o=t,i=getComputedStyle(e);e=[o.left,o.top,t.width+o.left,t.height+o.top],U.forEach(function(t,o){t=t[0].toUpperCase()+t.substr(1),"Top"===t||"Left"===t?e[o]+=parseFloat(i["border"+t+"Width"]):e[o]-=parseFloat(i["border"+t+"Width"])})}(),e}var w=function(){function t(t,e){for(var o=0;o<e.length;o++){var i=e[o];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,o,i){return o&&t(e.prototype,o),i&&t(e,i),e}}(),C=void 0;"undefined"==typeof C&&(C={modules:[]});var O=function(){var t=0;return function(){return++t}}(),E={},x=function(t){var e=t._tetherZeroElement;"undefined"==typeof e&&(e=t.createElement("div"),e.setAttribute("data-tether-id",O()),f(e.style,{top:0,left:0,position:"absolute"}),t.body.appendChild(e),t._tetherZeroElement=e);var o=e.getAttribute("data-tether-id");if("undefined"==typeof E[o]){E[o]={};var i=e.getBoundingClientRect();for(var n in i)E[o][n]=i[n];T(function(){delete E[o]})}return E[o]},A=[],T=function(t){A.push(t)},S=function(){for(var t=void 0;t=A.pop();)t()},W=function(){function t(){i(this,t)}return w(t,[{key:"on",value:function(t,e,o){var i=arguments.length<=3||void 0===arguments[3]?!1:arguments[3];"undefined"==typeof this.bindings&&(this.bindings={}),"undefined"==typeof this.bindings[t]&&(this.bindings[t]=[]),this.bindings[t].push({handler:e,ctx:o,once:i})}},{key:"once",value:function(t,e,o){this.on(t,e,o,!0)}},{key:"off",value:function(t,e){if("undefined"==typeof this.bindings||"undefined"==typeof this.bindings[t])if("undefined"==typeof e)delete this.bindings[t];else for(var o=0;o<this.bindings[t].length;)this.bindings[t][o].handler===e?this.bindings[t].splice(o,1):++o}},{key:"trigger",value:function(t){if("undefined"!=typeof this.bindings&&this.bindings[t]){for(var e=0,o=arguments.length,i=Array(o>1?o-1:0),n=1;o>n;n++)i[n-1]=arguments[n];for(;e<this.bindings[t].length;){var r=this.bindings[t][e],s=r.handler,a=r.ctx,f=r.once,h=a;"undefined"==typeof h&&(h=this),s.apply(h,i),f?this.bindings[t].splice(e,1):++e}}}}]),t}();C.Utils={getScrollParent:n,getBounds:r,getOffsetParent:s,extend:f,addClass:l,removeClass:h,hasClass:d,updateClasses:c,defer:T,flush:S,uniqueId:O,Evented:W,getScrollBarSize:a};var M=function(){function t(t,e){var o=[],i=!0,n=!1,r=void 0;try{for(var s,a=t[Symbol.iterator]();!(i=(s=a.next()).done)&&(o.push(s.value),!e||o.length!==e);i=!0);}catch(f){n=!0,r=f}finally{try{!i&&a["return"]&&a["return"]()}finally{if(n)throw r}}return o}return function(e,o){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,o);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),w=function(){function t(t,e){for(var o=0;o<e.length;o++){var i=e[o];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,o,i){return o&&t(e.prototype,o),i&&t(e,i),e}}();if("undefined"==typeof C)throw new Error("You must include the utils.js file before tether.js");var P=C.Utils,n=P.getScrollParent,r=P.getBounds,s=P.getOffsetParent,f=P.extend,l=P.addClass,h=P.removeClass,c=P.updateClasses,T=P.defer,S=P.flush,a=P.getScrollBarSize,k=function(){if("undefined"==typeof document)return"";for(var t=document.createElement("div"),e=["transform","webkitTransform","OTransform","MozTransform","msTransform"],o=0;o<e.length;++o){var i=e[o];if(void 0!==t.style[i])return i}}(),B=[],_=function(){B.forEach(function(t){t.position(!1)}),S()};!function(){var t=null,e=null,o=null,i=function n(){return"undefined"!=typeof e&&e>16?(e=Math.min(e-16,250),void(o=setTimeout(n,250))):void("undefined"!=typeof t&&m()-t<10||("undefined"!=typeof o&&(clearTimeout(o),o=null),t=m(),_(),e=m()-t))};"undefined"!=typeof window&&["resize","scroll","touchmove"].forEach(function(t){window.addEventListener(t,i)})}();var z={center:"center",left:"right",right:"left"},F={middle:"middle",top:"bottom",bottom:"top"},L={top:0,left:0,middle:"50%",center:"50%",bottom:"100%",right:"100%"},Y=function(t,e){var o=t.left,i=t.top;return"auto"===o&&(o=z[e.left]),"auto"===i&&(i=F[e.top]),{left:o,top:i}},H=function(t){var e=t.left,o=t.top;return"undefined"!=typeof L[t.left]&&(e=L[t.left]),"undefined"!=typeof L[t.top]&&(o=L[t.top]),{left:e,top:o}},X=function(t){var e=t.split(" "),o=M(e,2),i=o[0],n=o[1];return{top:i,left:n}},j=X,N=function(){function t(e){var o=this;i(this,t),this.position=this.position.bind(this),B.push(this),this.history=[],this.setOptions(e,!1),C.modules.forEach(function(t){"undefined"!=typeof t.initialize&&t.initialize.call(o)}),this.position()}return w(t,[{key:"getClass",value:function(){var t=arguments.length<=0||void 0===arguments[0]?"":arguments[0],e=this.options.classes;return"undefined"!=typeof e&&e[t]?this.options.classes[t]:this.options.classPrefix?this.options.classPrefix+"-"+t:t}},{key:"setOptions",value:function(t){var e=this,o=arguments.length<=1||void 0===arguments[1]?!0:arguments[1],i={offset:"0 0",targetOffset:"0 0",targetAttachment:"auto auto",classPrefix:"tether"};this.options=f(i,t);var r=this.options,s=r.element,a=r.target,h=r.targetModifier;if(this.element=s,this.target=a,this.targetModifier=h,"viewport"===this.target?(this.target=document.body,this.targetModifier="visible"):"scroll-handle"===this.target&&(this.target=document.body,this.targetModifier="scroll-handle"),["element","target"].forEach(function(t){if("undefined"==typeof e[t])throw new Error("Tether Error: Both element and target must be defined");"undefined"!=typeof e[t].jquery?e[t]=e[t][0]:"string"==typeof e[t]&&(e[t]=document.querySelector(e[t]))}),l(this.element,this.getClass("element")),this.options.addTargetClasses!==!1&&l(this.target,this.getClass("target")),!this.options.attachment)throw new Error("Tether Error: You must provide an attachment");this.targetAttachment=j(this.options.targetAttachment),this.attachment=j(this.options.attachment),this.offset=X(this.options.offset),this.targetOffset=X(this.options.targetOffset),"undefined"!=typeof this.scrollParent&&this.disable(),"scroll-handle"===this.targetModifier?this.scrollParent=this.target:this.scrollParent=n(this.target),this.options.enabled!==!1&&this.enable(o)}},{key:"getTargetBounds",value:function(){if("undefined"==typeof this.targetModifier)return r(this.target);if("visible"===this.targetModifier){if(this.target===document.body)return{top:pageYOffset,left:pageXOffset,height:innerHeight,width:innerWidth};var t=r(this.target),e={height:t.height,width:t.width,top:t.top,left:t.left};return e.height=Math.min(e.height,t.height-(pageYOffset-t.top)),e.height=Math.min(e.height,t.height-(t.top+t.height-(pageYOffset+innerHeight))),e.height=Math.min(innerHeight,e.height),e.height-=2,e.width=Math.min(e.width,t.width-(pageXOffset-t.left)),e.width=Math.min(e.width,t.width-(t.left+t.width-(pageXOffset+innerWidth))),e.width=Math.min(innerWidth,e.width),e.width-=2,e.top<pageYOffset&&(e.top=pageYOffset),e.left<pageXOffset&&(e.left=pageXOffset),e}if("scroll-handle"===this.targetModifier){var t=void 0,o=this.target;o===document.body?(o=document.documentElement,t={left:pageXOffset,top:pageYOffset,height:innerHeight,width:innerWidth}):t=r(o);var i=getComputedStyle(o),n=o.scrollWidth>o.clientWidth||[i.overflow,i.overflowX].indexOf("scroll")>=0||this.target!==document.body,s=0;n&&(s=15);var a=t.height-parseFloat(i.borderTopWidth)-parseFloat(i.borderBottomWidth)-s,e={width:15,height:.975*a*(a/o.scrollHeight),left:t.left+t.width-parseFloat(i.borderLeftWidth)-15},f=0;408>a&&this.target===document.body&&(f=-11e-5*Math.pow(a,2)-.00727*a+22.58),this.target!==document.body&&(e.height=Math.max(e.height,24));var h=this.target.scrollTop/(o.scrollHeight-a);return e.top=h*(a-e.height-f)+t.top+parseFloat(i.borderTopWidth),this.target===document.body&&(e.height=Math.max(e.height,24)),e}}},{key:"clearCache",value:function(){this._cache={}}},{key:"cache",value:function(t,e){return"undefined"==typeof this._cache&&(this._cache={}),"undefined"==typeof this._cache[t]&&(this._cache[t]=e.call(this)),this._cache[t]}},{key:"enable",value:function(){var t=arguments.length<=0||void 0===arguments[0]?!0:arguments[0];this.options.addTargetClasses!==!1&&l(this.target,this.getClass("enabled")),l(this.element,this.getClass("enabled")),this.enabled=!0,this.scrollParent!==document&&this.scrollParent.addEventListener("scroll",this.position),t&&this.position()}},{key:"disable",value:function(){h(this.target,this.getClass("enabled")),h(this.element,this.getClass("enabled")),this.enabled=!1,"undefined"!=typeof this.scrollParent&&this.scrollParent.removeEventListener("scroll",this.position)}},{key:"destroy",value:function(){var t=this;this.disable(),B.forEach(function(e,o){return e===t?void B.splice(o,1):void 0})}},{key:"updateAttachClasses",value:function(t,e){var o=this;t=t||this.attachment,e=e||this.targetAttachment;var i=["left","top","bottom","right","middle","center"];"undefined"!=typeof this._addAttachClasses&&this._addAttachClasses.length&&this._addAttachClasses.splice(0,this._addAttachClasses.length),"undefined"==typeof this._addAttachClasses&&(this._addAttachClasses=[]);var n=this._addAttachClasses;t.top&&n.push(this.getClass("element-attached")+"-"+t.top),t.left&&n.push(this.getClass("element-attached")+"-"+t.left),e.top&&n.push(this.getClass("target-attached")+"-"+e.top),e.left&&n.push(this.getClass("target-attached")+"-"+e.left);var r=[];i.forEach(function(t){r.push(o.getClass("element-attached")+"-"+t),r.push(o.getClass("target-attached")+"-"+t)}),T(function(){"undefined"!=typeof o._addAttachClasses&&(c(o.element,o._addAttachClasses,r),o.options.addTargetClasses!==!1&&c(o.target,o._addAttachClasses,r),delete o._addAttachClasses)})}},{key:"position",value:function(){var t=this,e=arguments.length<=0||void 0===arguments[0]?!0:arguments[0];if(this.enabled){this.clearCache();var o=Y(this.targetAttachment,this.attachment);this.updateAttachClasses(this.attachment,o);var i=this.cache("element-bounds",function(){return r(t.element)}),n=i.width,f=i.height;if(0===n&&0===f&&"undefined"!=typeof this.lastSize){var h=this.lastSize;n=h.width,f=h.height}else this.lastSize={width:n,height:f};var l=this.cache("target-bounds",function(){return t.getTargetBounds()}),d=l,u=y(H(this.attachment),{width:n,height:f}),p=y(H(o),d),c=y(this.offset,{width:n,height:f}),g=y(this.targetOffset,d);u=v(u,c),p=v(p,g);for(var m=l.left+p.left-u.left,b=l.top+p.top-u.top,w=0;w<C.modules.length;++w){var O=C.modules[w],E=O.position.call(this,{left:m,top:b,targetAttachment:o,targetPos:l,elementPos:i,offset:u,targetOffset:p,manualOffset:c,manualTargetOffset:g,scrollbarSize:A,attachment:this.attachment});if(E===!1)return!1;"undefined"!=typeof E&&"object"==typeof E&&(b=E.top,m=E.left)}var x={page:{top:b,left:m},viewport:{top:b-pageYOffset,bottom:pageYOffset-b-f+innerHeight,left:m-pageXOffset,right:pageXOffset-m-n+innerWidth}},A=void 0;return document.body.scrollWidth>window.innerWidth&&(A=this.cache("scrollbar-size",a),x.viewport.bottom-=A.height),document.body.scrollHeight>window.innerHeight&&(A=this.cache("scrollbar-size",a),x.viewport.right-=A.width),(-1===["","static"].indexOf(document.body.style.position)||-1===["","static"].indexOf(document.body.parentElement.style.position))&&(x.page.bottom=document.body.scrollHeight-b-f,x.page.right=document.body.scrollWidth-m-n),"undefined"!=typeof this.options.optimizations&&this.options.optimizations.moveElement!==!1&&"undefined"==typeof this.targetModifier&&!function(){var e=t.cache("target-offsetparent",function(){return s(t.target)}),o=t.cache("target-offsetparent-bounds",function(){return r(e)}),i=getComputedStyle(e),n=o,a={};if(["Top","Left","Bottom","Right"].forEach(function(t){a[t.toLowerCase()]=parseFloat(i["border"+t+"Width"])}),o.right=document.body.scrollWidth-o.left-n.width+a.right,o.bottom=document.body.scrollHeight-o.top-n.height+a.bottom,x.page.top>=o.top+a.top&&x.page.bottom>=o.bottom&&x.page.left>=o.left+a.left&&x.page.right>=o.right){var f=e.scrollTop,h=e.scrollLeft;x.offset={top:x.page.top-o.top+f-a.top,left:x.page.left-o.left+h-a.left}}}(),this.move(x),this.history.unshift(x),this.history.length>3&&this.history.pop(),e&&S(),!0}}},{key:"move",value:function(t){var e=this;if("undefined"!=typeof this.element.parentNode){var o={};for(var i in t){o[i]={};for(var n in t[i]){for(var r=!1,a=0;a<this.history.length;++a){var h=this.history[a];if("undefined"!=typeof h[i]&&!g(h[i][n],t[i][n])){r=!0;break}}r||(o[i][n]=!0)}}var l={top:"",left:"",right:"",bottom:""},d=function(t,o){var i="undefined"!=typeof e.options.optimizations,n=i?e.options.optimizations.gpu:null;if(n!==!1){var r=void 0,s=void 0;t.top?(l.top=0,r=o.top):(l.bottom=0,r=-o.bottom),t.left?(l.left=0,s=o.left):(l.right=0,s=-o.right),l[k]="translateX("+Math.round(s)+"px) translateY("+Math.round(r)+"px)","msTransform"!==k&&(l[k]+=" translateZ(0)")}else t.top?l.top=o.top+"px":l.bottom=o.bottom+"px",t.left?l.left=o.left+"px":l.right=o.right+"px"},u=!1;if((o.page.top||o.page.bottom)&&(o.page.left||o.page.right)?(l.position="absolute",d(o.page,t.page)):(o.viewport.top||o.viewport.bottom)&&(o.viewport.left||o.viewport.right)?(l.position="fixed",d(o.viewport,t.viewport)):"undefined"!=typeof o.offset&&o.offset.top&&o.offset.left?!function(){l.position="absolute";var i=e.cache("target-offsetparent",function(){return s(e.target)});s(e.element)!==i&&T(function(){e.element.parentNode.removeChild(e.element),i.appendChild(e.element)}),d(o.offset,t.offset),u=!0}():(l.position="absolute",d({top:!0,left:!0},t.page)),!u){for(var p=!0,c=this.element.parentNode;c&&"BODY"!==c.tagName;){if("static"!==getComputedStyle(c).position){p=!1;break}c=c.parentNode}p||(this.element.parentNode.removeChild(this.element),document.body.appendChild(this.element))}var m={},v=!1;for(var n in l){var y=l[n],b=this.element.style[n];""!==b&&""!==y&&["top","left","bottom","right"].indexOf(n)>=0&&(b=parseFloat(b),y=parseFloat(y)),b!==y&&(v=!0,m[n]=y)}v&&T(function(){f(e.element.style,m)})}}}]),t}();N.modules=[],C.position=_;var R=f(N,C),M=function(){function t(t,e){var o=[],i=!0,n=!1,r=void 0;try{for(var s,a=t[Symbol.iterator]();!(i=(s=a.next()).done)&&(o.push(s.value),!e||o.length!==e);i=!0);}catch(f){n=!0,r=f}finally{try{!i&&a["return"]&&a["return"]()}finally{if(n)throw r}}return o}return function(e,o){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,o);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),P=C.Utils,r=P.getBounds,f=P.extend,c=P.updateClasses,T=P.defer,U=["left","top","right","bottom"];C.modules.push({position:function(t){var e=this,o=t.top,i=t.left,n=t.targetAttachment;if(!this.options.constraints)return!0;var s=this.cache("element-bounds",function(){return r(e.element)}),a=s.height,h=s.width;if(0===h&&0===a&&"undefined"!=typeof this.lastSize){var l=this.lastSize;h=l.width,a=l.height}var d=this.cache("target-bounds",function(){return e.getTargetBounds()}),u=d.height,p=d.width,g=[this.getClass("pinned"),this.getClass("out-of-bounds")];this.options.constraints.forEach(function(t){var e=t.outOfBoundsClass,o=t.pinnedClass;e&&g.push(e),o&&g.push(o)}),g.forEach(function(t){["left","top","right","bottom"].forEach(function(e){g.push(t+"-"+e)})});var m=[],v=f({},n),y=f({},this.attachment);return this.options.constraints.forEach(function(t){var r=t.to,s=t.attachment,f=t.pin;"undefined"==typeof s&&(s="");var l=void 0,d=void 0;if(s.indexOf(" ")>=0){var c=s.split(" "),g=M(c,2);d=g[0],l=g[1]}else l=d=s;var w=b(e,r);("target"===d||"both"===d)&&(o<w[1]&&"top"===v.top&&(o+=u,v.top="bottom"),o+a>w[3]&&"bottom"===v.top&&(o-=u,v.top="top")),"together"===d&&(o<w[1]&&"top"===v.top&&("bottom"===y.top?(o+=u,v.top="bottom",o+=a,y.top="top"):"top"===y.top&&(o+=u,v.top="bottom",o-=a,y.top="bottom")),o+a>w[3]&&"bottom"===v.top&&("top"===y.top?(o-=u,v.top="top",o-=a,y.top="bottom"):"bottom"===y.top&&(o-=u,v.top="top",o+=a,y.top="top")),"middle"===v.top&&(o+a>w[3]&&"top"===y.top?(o-=a,y.top="bottom"):o<w[1]&&"bottom"===y.top&&(o+=a,y.top="top"))),("target"===l||"both"===l)&&(i<w[0]&&"left"===v.left&&(i+=p,v.left="right"),i+h>w[2]&&"right"===v.left&&(i-=p,v.left="left")),"together"===l&&(i<w[0]&&"left"===v.left?"right"===y.left?(i+=p,v.left="right",i+=h,y.left="left"):"left"===y.left&&(i+=p,v.left="right",i-=h,y.left="right"):i+h>w[2]&&"right"===v.left?"left"===y.left?(i-=p,v.left="left",i-=h,y.left="right"):"right"===y.left&&(i-=p,v.left="left",i+=h,y.left="left"):"center"===v.left&&(i+h>w[2]&&"left"===y.left?(i-=h,y.left="right"):i<w[0]&&"right"===y.left&&(i+=h,y.left="left"))),("element"===d||"both"===d)&&(o<w[1]&&"bottom"===y.top&&(o+=a,y.top="top"),o+a>w[3]&&"top"===y.top&&(o-=a,y.top="bottom")),("element"===l||"both"===l)&&(i<w[0]&&("right"===y.left?(i+=h,y.left="left"):"center"===y.left&&(i+=h/2,y.left="left")),i+h>w[2]&&("left"===y.left?(i-=h,y.left="right"):"center"===y.left&&(i-=h/2,y.left="right"))),"string"==typeof f?f=f.split(",").map(function(t){return t.trim()}):f===!0&&(f=["top","left","right","bottom"]),f=f||[];var C=[],O=[];o<w[1]&&(f.indexOf("top")>=0?(o=w[1],C.push("top")):O.push("top")),o+a>w[3]&&(f.indexOf("bottom")>=0?(o=w[3]-a,C.push("bottom")):O.push("bottom")),i<w[0]&&(f.indexOf("left")>=0?(i=w[0],C.push("left")):O.push("left")),i+h>w[2]&&(f.indexOf("right")>=0?(i=w[2]-h,C.push("right")):O.push("right")),C.length&&!function(){var t=void 0;t="undefined"!=typeof e.options.pinnedClass?e.options.pinnedClass:e.getClass("pinned"),m.push(t),C.forEach(function(e){m.push(t+"-"+e)})}(),O.length&&!function(){var t=void 0;t="undefined"!=typeof e.options.outOfBoundsClass?e.options.outOfBoundsClass:e.getClass("out-of-bounds"),m.push(t),O.forEach(function(e){m.push(t+"-"+e)})}(),(C.indexOf("left")>=0||C.indexOf("right")>=0)&&(y.left=v.left=!1),(C.indexOf("top")>=0||C.indexOf("bottom")>=0)&&(y.top=v.top=!1),(v.top!==n.top||v.left!==n.left||y.top!==e.attachment.top||y.left!==e.attachment.left)&&e.updateAttachClasses(y,v)}),T(function(){e.options.addTargetClasses!==!1&&c(e.target,m,g),c(e.element,m,g)}),{top:o,left:i}}});var P=C.Utils,r=P.getBounds,c=P.updateClasses,T=P.defer;C.modules.push({position:function(t){var e=this,o=t.top,i=t.left,n=this.cache("element-bounds",function(){return r(e.element)}),s=n.height,a=n.width,f=this.getTargetBounds(),h=o+s,l=i+a,d=[];o<=f.bottom&&h>=f.top&&["left","right"].forEach(function(t){var e=f[t];(e===i||e===l)&&d.push(t)}),i<=f.right&&l>=f.left&&["top","bottom"].forEach(function(t){var e=f[t];(e===o||e===h)&&d.push(t)});var u=[],p=[],g=["left","top","right","bottom"];return u.push(this.getClass("abutted")),g.forEach(function(t){u.push(e.getClass("abutted")+"-"+t)}),d.length&&p.push(this.getClass("abutted")),d.forEach(function(t){p.push(e.getClass("abutted")+"-"+t)}),T(function(){e.options.addTargetClasses!==!1&&c(e.target,p,u),c(e.element,p,u)}),!0}});var M=function(){function t(t,e){var o=[],i=!0,n=!1,r=void 0;try{for(var s,a=t[Symbol.iterator]();!(i=(s=a.next()).done)&&(o.push(s.value),!e||o.length!==e);i=!0);}catch(f){n=!0,r=f}finally{try{!i&&a["return"]&&a["return"]()}finally{if(n)throw r}}return o}return function(e,o){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,o);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}();return C.modules.push({position:function(t){var e=t.top,o=t.left;if(this.options.shift){var i=this.options.shift;"function"==typeof this.options.shift&&(i=this.options.shift.call(this,{top:e,left:o}));var n=void 0,r=void 0;if("string"==typeof i){i=i.split(" "),i[1]=i[1]||i[0];var s=i,a=M(s,2);n=a[0],r=a[1],n=parseFloat(n,10),r=parseFloat(r,10)}else n=i.top,r=i.left;return e+=n,o+=r,{top:e,left:o}}}}),R});
/*!
 * Bootstrap v4.0.0-alpha.6 (https://getbootstrap.com)
 * Copyright 2011-2017 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");+function(t){var e=t.fn.jquery.split(" ")[0].split(".");if(e[0]<2&&e[1]<9||1==e[0]&&9==e[1]&&e[2]<1||e[0]>=4)throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0")}(jQuery),+function(){function t(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function e(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}(),r=function(t){function e(t){return{}.toString.call(t).match(/\s([a-zA-Z]+)/)[1].toLowerCase()}function n(t){return(t[0]||t).nodeType}function i(){return{bindType:a.end,delegateType:a.end,handle:function(e){if(t(e.target).is(this))return e.handleObj.handler.apply(this,arguments)}}}function o(){if(window.QUnit)return!1;var t=document.createElement("bootstrap");for(var e in h)if(void 0!==t.style[e])return{end:h[e]};return!1}function r(e){var n=this,i=!1;return t(this).one(c.TRANSITION_END,function(){i=!0}),setTimeout(function(){i||c.triggerTransitionEnd(n)},e),this}function s(){a=o(),t.fn.emulateTransitionEnd=r,c.supportsTransitionEnd()&&(t.event.special[c.TRANSITION_END]=i())}var a=!1,l=1e6,h={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"},c={TRANSITION_END:"bsTransitionEnd",getUID:function(t){do t+=~~(Math.random()*l);while(document.getElementById(t));return t},getSelectorFromElement:function(t){var e=t.getAttribute("data-target");return e||(e=t.getAttribute("href")||"",e=/^#[a-z]/i.test(e)?e:null),e},reflow:function(t){return t.offsetHeight},triggerTransitionEnd:function(e){t(e).trigger(a.end)},supportsTransitionEnd:function(){return Boolean(a)},typeCheckConfig:function(t,i,o){for(var r in o)if(o.hasOwnProperty(r)){var s=o[r],a=i[r],l=a&&n(a)?"element":e(a);if(!new RegExp(s).test(l))throw new Error(t.toUpperCase()+": "+('Option "'+r+'" provided type "'+l+'" ')+('but expected type "'+s+'".'))}}};return s(),c}(jQuery),s=(function(t){var e="alert",i="4.0.0-alpha.6",s="bs.alert",a="."+s,l=".data-api",h=t.fn[e],c=150,u={DISMISS:'[data-dismiss="alert"]'},d={CLOSE:"close"+a,CLOSED:"closed"+a,CLICK_DATA_API:"click"+a+l},f={ALERT:"alert",FADE:"fade",SHOW:"show"},_=function(){function e(t){n(this,e),this._element=t}return e.prototype.close=function(t){t=t||this._element;var e=this._getRootElement(t),n=this._triggerCloseEvent(e);n.isDefaultPrevented()||this._removeElement(e)},e.prototype.dispose=function(){t.removeData(this._element,s),this._element=null},e.prototype._getRootElement=function(e){var n=r.getSelectorFromElement(e),i=!1;return n&&(i=t(n)[0]),i||(i=t(e).closest("."+f.ALERT)[0]),i},e.prototype._triggerCloseEvent=function(e){var n=t.Event(d.CLOSE);return t(e).trigger(n),n},e.prototype._removeElement=function(e){var n=this;return t(e).removeClass(f.SHOW),r.supportsTransitionEnd()&&t(e).hasClass(f.FADE)?void t(e).one(r.TRANSITION_END,function(t){return n._destroyElement(e,t)}).emulateTransitionEnd(c):void this._destroyElement(e)},e.prototype._destroyElement=function(e){t(e).detach().trigger(d.CLOSED).remove()},e._jQueryInterface=function(n){return this.each(function(){var i=t(this),o=i.data(s);o||(o=new e(this),i.data(s,o)),"close"===n&&o[n](this)})},e._handleDismiss=function(t){return function(e){e&&e.preventDefault(),t.close(this)}},o(e,null,[{key:"VERSION",get:function(){return i}}]),e}();return t(document).on(d.CLICK_DATA_API,u.DISMISS,_._handleDismiss(new _)),t.fn[e]=_._jQueryInterface,t.fn[e].Constructor=_,t.fn[e].noConflict=function(){return t.fn[e]=h,_._jQueryInterface},_}(jQuery),function(t){var e="button",i="4.0.0-alpha.6",r="bs.button",s="."+r,a=".data-api",l=t.fn[e],h={ACTIVE:"active",BUTTON:"btn",FOCUS:"focus"},c={DATA_TOGGLE_CARROT:'[data-toggle^="button"]',DATA_TOGGLE:'[data-toggle="buttons"]',INPUT:"input",ACTIVE:".active",BUTTON:".btn"},u={CLICK_DATA_API:"click"+s+a,FOCUS_BLUR_DATA_API:"focus"+s+a+" "+("blur"+s+a)},d=function(){function e(t){n(this,e),this._element=t}return e.prototype.toggle=function(){var e=!0,n=t(this._element).closest(c.DATA_TOGGLE)[0];if(n){var i=t(this._element).find(c.INPUT)[0];if(i){if("radio"===i.type)if(i.checked&&t(this._element).hasClass(h.ACTIVE))e=!1;else{var o=t(n).find(c.ACTIVE)[0];o&&t(o).removeClass(h.ACTIVE)}e&&(i.checked=!t(this._element).hasClass(h.ACTIVE),t(i).trigger("change")),i.focus()}}this._element.setAttribute("aria-pressed",!t(this._element).hasClass(h.ACTIVE)),e&&t(this._element).toggleClass(h.ACTIVE)},e.prototype.dispose=function(){t.removeData(this._element,r),this._element=null},e._jQueryInterface=function(n){return this.each(function(){var i=t(this).data(r);i||(i=new e(this),t(this).data(r,i)),"toggle"===n&&i[n]()})},o(e,null,[{key:"VERSION",get:function(){return i}}]),e}();return t(document).on(u.CLICK_DATA_API,c.DATA_TOGGLE_CARROT,function(e){e.preventDefault();var n=e.target;t(n).hasClass(h.BUTTON)||(n=t(n).closest(c.BUTTON)),d._jQueryInterface.call(t(n),"toggle")}).on(u.FOCUS_BLUR_DATA_API,c.DATA_TOGGLE_CARROT,function(e){var n=t(e.target).closest(c.BUTTON)[0];t(n).toggleClass(h.FOCUS,/^focus(in)?$/.test(e.type))}),t.fn[e]=d._jQueryInterface,t.fn[e].Constructor=d,t.fn[e].noConflict=function(){return t.fn[e]=l,d._jQueryInterface},d}(jQuery),function(t){var e="carousel",s="4.0.0-alpha.6",a="bs.carousel",l="."+a,h=".data-api",c=t.fn[e],u=600,d=37,f=39,_={interval:5e3,keyboard:!0,slide:!1,pause:"hover",wrap:!0},g={interval:"(number|boolean)",keyboard:"boolean",slide:"(boolean|string)",pause:"(string|boolean)",wrap:"boolean"},p={NEXT:"next",PREV:"prev",LEFT:"left",RIGHT:"right"},m={SLIDE:"slide"+l,SLID:"slid"+l,KEYDOWN:"keydown"+l,MOUSEENTER:"mouseenter"+l,MOUSELEAVE:"mouseleave"+l,LOAD_DATA_API:"load"+l+h,CLICK_DATA_API:"click"+l+h},E={CAROUSEL:"carousel",ACTIVE:"active",SLIDE:"slide",RIGHT:"carousel-item-right",LEFT:"carousel-item-left",NEXT:"carousel-item-next",PREV:"carousel-item-prev",ITEM:"carousel-item"},v={ACTIVE:".active",ACTIVE_ITEM:".active.carousel-item",ITEM:".carousel-item",NEXT_PREV:".carousel-item-next, .carousel-item-prev",INDICATORS:".carousel-indicators",DATA_SLIDE:"[data-slide], [data-slide-to]",DATA_RIDE:'[data-ride="carousel"]'},T=function(){function h(e,i){n(this,h),this._items=null,this._interval=null,this._activeElement=null,this._isPaused=!1,this._isSliding=!1,this._config=this._getConfig(i),this._element=t(e)[0],this._indicatorsElement=t(this._element).find(v.INDICATORS)[0],this._addEventListeners()}return h.prototype.next=function(){if(this._isSliding)throw new Error("Carousel is sliding");this._slide(p.NEXT)},h.prototype.nextWhenVisible=function(){document.hidden||this.next()},h.prototype.prev=function(){if(this._isSliding)throw new Error("Carousel is sliding");this._slide(p.PREVIOUS)},h.prototype.pause=function(e){e||(this._isPaused=!0),t(this._element).find(v.NEXT_PREV)[0]&&r.supportsTransitionEnd()&&(r.triggerTransitionEnd(this._element),this.cycle(!0)),clearInterval(this._interval),this._interval=null},h.prototype.cycle=function(t){t||(this._isPaused=!1),this._interval&&(clearInterval(this._interval),this._interval=null),this._config.interval&&!this._isPaused&&(this._interval=setInterval((document.visibilityState?this.nextWhenVisible:this.next).bind(this),this._config.interval))},h.prototype.to=function(e){var n=this;this._activeElement=t(this._element).find(v.ACTIVE_ITEM)[0];var i=this._getItemIndex(this._activeElement);if(!(e>this._items.length-1||e<0)){if(this._isSliding)return void t(this._element).one(m.SLID,function(){return n.to(e)});if(i===e)return this.pause(),void this.cycle();var o=e>i?p.NEXT:p.PREVIOUS;this._slide(o,this._items[e])}},h.prototype.dispose=function(){t(this._element).off(l),t.removeData(this._element,a),this._items=null,this._config=null,this._element=null,this._interval=null,this._isPaused=null,this._isSliding=null,this._activeElement=null,this._indicatorsElement=null},h.prototype._getConfig=function(n){return n=t.extend({},_,n),r.typeCheckConfig(e,n,g),n},h.prototype._addEventListeners=function(){var e=this;this._config.keyboard&&t(this._element).on(m.KEYDOWN,function(t){return e._keydown(t)}),"hover"!==this._config.pause||"ontouchstart"in document.documentElement||t(this._element).on(m.MOUSEENTER,function(t){return e.pause(t)}).on(m.MOUSELEAVE,function(t){return e.cycle(t)})},h.prototype._keydown=function(t){if(!/input|textarea/i.test(t.target.tagName))switch(t.which){case d:t.preventDefault(),this.prev();break;case f:t.preventDefault(),this.next();break;default:return}},h.prototype._getItemIndex=function(e){return this._items=t.makeArray(t(e).parent().find(v.ITEM)),this._items.indexOf(e)},h.prototype._getItemByDirection=function(t,e){var n=t===p.NEXT,i=t===p.PREVIOUS,o=this._getItemIndex(e),r=this._items.length-1,s=i&&0===o||n&&o===r;if(s&&!this._config.wrap)return e;var a=t===p.PREVIOUS?-1:1,l=(o+a)%this._items.length;return l===-1?this._items[this._items.length-1]:this._items[l]},h.prototype._triggerSlideEvent=function(e,n){var i=t.Event(m.SLIDE,{relatedTarget:e,direction:n});return t(this._element).trigger(i),i},h.prototype._setActiveIndicatorElement=function(e){if(this._indicatorsElement){t(this._indicatorsElement).find(v.ACTIVE).removeClass(E.ACTIVE);var n=this._indicatorsElement.children[this._getItemIndex(e)];n&&t(n).addClass(E.ACTIVE)}},h.prototype._slide=function(e,n){var i=this,o=t(this._element).find(v.ACTIVE_ITEM)[0],s=n||o&&this._getItemByDirection(e,o),a=Boolean(this._interval),l=void 0,h=void 0,c=void 0;if(e===p.NEXT?(l=E.LEFT,h=E.NEXT,c=p.LEFT):(l=E.RIGHT,h=E.PREV,c=p.RIGHT),s&&t(s).hasClass(E.ACTIVE))return void(this._isSliding=!1);var d=this._triggerSlideEvent(s,c);if(!d.isDefaultPrevented()&&o&&s){this._isSliding=!0,a&&this.pause(),this._setActiveIndicatorElement(s);var f=t.Event(m.SLID,{relatedTarget:s,direction:c});r.supportsTransitionEnd()&&t(this._element).hasClass(E.SLIDE)?(t(s).addClass(h),r.reflow(s),t(o).addClass(l),t(s).addClass(l),t(o).one(r.TRANSITION_END,function(){t(s).removeClass(l+" "+h).addClass(E.ACTIVE),t(o).removeClass(E.ACTIVE+" "+h+" "+l),i._isSliding=!1,setTimeout(function(){return t(i._element).trigger(f)},0)}).emulateTransitionEnd(u)):(t(o).removeClass(E.ACTIVE),t(s).addClass(E.ACTIVE),this._isSliding=!1,t(this._element).trigger(f)),a&&this.cycle()}},h._jQueryInterface=function(e){return this.each(function(){var n=t(this).data(a),o=t.extend({},_,t(this).data());"object"===("undefined"==typeof e?"undefined":i(e))&&t.extend(o,e);var r="string"==typeof e?e:o.slide;if(n||(n=new h(this,o),t(this).data(a,n)),"number"==typeof e)n.to(e);else if("string"==typeof r){if(void 0===n[r])throw new Error('No method named "'+r+'"');n[r]()}else o.interval&&(n.pause(),n.cycle())})},h._dataApiClickHandler=function(e){var n=r.getSelectorFromElement(this);if(n){var i=t(n)[0];if(i&&t(i).hasClass(E.CAROUSEL)){var o=t.extend({},t(i).data(),t(this).data()),s=this.getAttribute("data-slide-to");s&&(o.interval=!1),h._jQueryInterface.call(t(i),o),s&&t(i).data(a).to(s),e.preventDefault()}}},o(h,null,[{key:"VERSION",get:function(){return s}},{key:"Default",get:function(){return _}}]),h}();return t(document).on(m.CLICK_DATA_API,v.DATA_SLIDE,T._dataApiClickHandler),t(window).on(m.LOAD_DATA_API,function(){t(v.DATA_RIDE).each(function(){var e=t(this);T._jQueryInterface.call(e,e.data())})}),t.fn[e]=T._jQueryInterface,t.fn[e].Constructor=T,t.fn[e].noConflict=function(){return t.fn[e]=c,T._jQueryInterface},T}(jQuery),function(t){var e="collapse",s="4.0.0-alpha.6",a="bs.collapse",l="."+a,h=".data-api",c=t.fn[e],u=600,d={toggle:!0,parent:""},f={toggle:"boolean",parent:"string"},_={SHOW:"show"+l,SHOWN:"shown"+l,HIDE:"hide"+l,HIDDEN:"hidden"+l,CLICK_DATA_API:"click"+l+h},g={SHOW:"show",COLLAPSE:"collapse",COLLAPSING:"collapsing",COLLAPSED:"collapsed"},p={WIDTH:"width",HEIGHT:"height"},m={ACTIVES:".card > .show, .card > .collapsing",DATA_TOGGLE:'[data-toggle="collapse"]'},E=function(){function l(e,i){n(this,l),this._isTransitioning=!1,this._element=e,this._config=this._getConfig(i),this._triggerArray=t.makeArray(t('[data-toggle="collapse"][href="#'+e.id+'"],'+('[data-toggle="collapse"][data-target="#'+e.id+'"]'))),this._parent=this._config.parent?this._getParent():null,this._config.parent||this._addAriaAndCollapsedClass(this._element,this._triggerArray),this._config.toggle&&this.toggle()}return l.prototype.toggle=function(){t(this._element).hasClass(g.SHOW)?this.hide():this.show()},l.prototype.show=function(){var e=this;if(this._isTransitioning)throw new Error("Collapse is transitioning");if(!t(this._element).hasClass(g.SHOW)){var n=void 0,i=void 0;if(this._parent&&(n=t.makeArray(t(this._parent).find(m.ACTIVES)),n.length||(n=null)),!(n&&(i=t(n).data(a),i&&i._isTransitioning))){var o=t.Event(_.SHOW);if(t(this._element).trigger(o),!o.isDefaultPrevented()){n&&(l._jQueryInterface.call(t(n),"hide"),i||t(n).data(a,null));var s=this._getDimension();t(this._element).removeClass(g.COLLAPSE).addClass(g.COLLAPSING),this._element.style[s]=0,this._element.setAttribute("aria-expanded",!0),this._triggerArray.length&&t(this._triggerArray).removeClass(g.COLLAPSED).attr("aria-expanded",!0),this.setTransitioning(!0);var h=function(){t(e._element).removeClass(g.COLLAPSING).addClass(g.COLLAPSE).addClass(g.SHOW),e._element.style[s]="",e.setTransitioning(!1),t(e._element).trigger(_.SHOWN)};if(!r.supportsTransitionEnd())return void h();var c=s[0].toUpperCase()+s.slice(1),d="scroll"+c;t(this._element).one(r.TRANSITION_END,h).emulateTransitionEnd(u),this._element.style[s]=this._element[d]+"px"}}}},l.prototype.hide=function(){var e=this;if(this._isTransitioning)throw new Error("Collapse is transitioning");if(t(this._element).hasClass(g.SHOW)){var n=t.Event(_.HIDE);if(t(this._element).trigger(n),!n.isDefaultPrevented()){var i=this._getDimension(),o=i===p.WIDTH?"offsetWidth":"offsetHeight";this._element.style[i]=this._element[o]+"px",r.reflow(this._element),t(this._element).addClass(g.COLLAPSING).removeClass(g.COLLAPSE).removeClass(g.SHOW),this._element.setAttribute("aria-expanded",!1),this._triggerArray.length&&t(this._triggerArray).addClass(g.COLLAPSED).attr("aria-expanded",!1),this.setTransitioning(!0);var s=function(){e.setTransitioning(!1),t(e._element).removeClass(g.COLLAPSING).addClass(g.COLLAPSE).trigger(_.HIDDEN)};return this._element.style[i]="",r.supportsTransitionEnd()?void t(this._element).one(r.TRANSITION_END,s).emulateTransitionEnd(u):void s()}}},l.prototype.setTransitioning=function(t){this._isTransitioning=t},l.prototype.dispose=function(){t.removeData(this._element,a),this._config=null,this._parent=null,this._element=null,this._triggerArray=null,this._isTransitioning=null},l.prototype._getConfig=function(n){return n=t.extend({},d,n),n.toggle=Boolean(n.toggle),r.typeCheckConfig(e,n,f),n},l.prototype._getDimension=function(){var e=t(this._element).hasClass(p.WIDTH);return e?p.WIDTH:p.HEIGHT},l.prototype._getParent=function(){var e=this,n=t(this._config.parent)[0],i='[data-toggle="collapse"][data-parent="'+this._config.parent+'"]';return t(n).find(i).each(function(t,n){e._addAriaAndCollapsedClass(l._getTargetFromElement(n),[n])}),n},l.prototype._addAriaAndCollapsedClass=function(e,n){if(e){var i=t(e).hasClass(g.SHOW);e.setAttribute("aria-expanded",i),n.length&&t(n).toggleClass(g.COLLAPSED,!i).attr("aria-expanded",i)}},l._getTargetFromElement=function(e){var n=r.getSelectorFromElement(e);return n?t(n)[0]:null},l._jQueryInterface=function(e){return this.each(function(){var n=t(this),o=n.data(a),r=t.extend({},d,n.data(),"object"===("undefined"==typeof e?"undefined":i(e))&&e);if(!o&&r.toggle&&/show|hide/.test(e)&&(r.toggle=!1),o||(o=new l(this,r),n.data(a,o)),"string"==typeof e){if(void 0===o[e])throw new Error('No method named "'+e+'"');o[e]()}})},o(l,null,[{key:"VERSION",get:function(){return s}},{key:"Default",get:function(){return d}}]),l}();return t(document).on(_.CLICK_DATA_API,m.DATA_TOGGLE,function(e){e.preventDefault();var n=E._getTargetFromElement(this),i=t(n).data(a),o=i?"toggle":t(this).data();E._jQueryInterface.call(t(n),o)}),t.fn[e]=E._jQueryInterface,t.fn[e].Constructor=E,t.fn[e].noConflict=function(){return t.fn[e]=c,E._jQueryInterface},E}(jQuery),function(t){var e="dropdown",i="4.0.0-alpha.6",s="bs.dropdown",a="."+s,l=".data-api",h=t.fn[e],c=27,u=38,d=40,f=3,_={HIDE:"hide"+a,HIDDEN:"hidden"+a,SHOW:"show"+a,SHOWN:"shown"+a,CLICK:"click"+a,CLICK_DATA_API:"click"+a+l,FOCUSIN_DATA_API:"focusin"+a+l,KEYDOWN_DATA_API:"keydown"+a+l},g={BACKDROP:"dropdown-backdrop",DISABLED:"disabled",SHOW:"show"},p={BACKDROP:".dropdown-backdrop",DATA_TOGGLE:'[data-toggle="dropdown"]',FORM_CHILD:".dropdown form",ROLE_MENU:'[role="menu"]',ROLE_LISTBOX:'[role="listbox"]',NAVBAR_NAV:".navbar-nav",VISIBLE_ITEMS:'[role="menu"] li:not(.disabled) a, [role="listbox"] li:not(.disabled) a'},m=function(){function e(t){n(this,e),this._element=t,this._addEventListeners()}return e.prototype.toggle=function(){if(this.disabled||t(this).hasClass(g.DISABLED))return!1;var n=e._getParentFromElement(this),i=t(n).hasClass(g.SHOW);if(e._clearMenus(),i)return!1;if("ontouchstart"in document.documentElement&&!t(n).closest(p.NAVBAR_NAV).length){var o=document.createElement("div");o.className=g.BACKDROP,t(o).insertBefore(this),t(o).on("click",e._clearMenus)}var r={relatedTarget:this},s=t.Event(_.SHOW,r);return t(n).trigger(s),!s.isDefaultPrevented()&&(this.focus(),this.setAttribute("aria-expanded",!0),t(n).toggleClass(g.SHOW),t(n).trigger(t.Event(_.SHOWN,r)),!1)},e.prototype.dispose=function(){t.removeData(this._element,s),t(this._element).off(a),this._element=null},e.prototype._addEventListeners=function(){t(this._element).on(_.CLICK,this.toggle)},e._jQueryInterface=function(n){return this.each(function(){var i=t(this).data(s);if(i||(i=new e(this),t(this).data(s,i)),"string"==typeof n){if(void 0===i[n])throw new Error('No method named "'+n+'"');i[n].call(this)}})},e._clearMenus=function(n){if(!n||n.which!==f){var i=t(p.BACKDROP)[0];i&&i.parentNode.removeChild(i);for(var o=t.makeArray(t(p.DATA_TOGGLE)),r=0;r<o.length;r++){var s=e._getParentFromElement(o[r]),a={relatedTarget:o[r]};if(t(s).hasClass(g.SHOW)&&!(n&&("click"===n.type&&/input|textarea/i.test(n.target.tagName)||"focusin"===n.type)&&t.contains(s,n.target))){var l=t.Event(_.HIDE,a);t(s).trigger(l),l.isDefaultPrevented()||(o[r].setAttribute("aria-expanded","false"),t(s).removeClass(g.SHOW).trigger(t.Event(_.HIDDEN,a)))}}}},e._getParentFromElement=function(e){var n=void 0,i=r.getSelectorFromElement(e);return i&&(n=t(i)[0]),n||e.parentNode},e._dataApiKeydownHandler=function(n){if(/(38|40|27|32)/.test(n.which)&&!/input|textarea/i.test(n.target.tagName)&&(n.preventDefault(),n.stopPropagation(),!this.disabled&&!t(this).hasClass(g.DISABLED))){var i=e._getParentFromElement(this),o=t(i).hasClass(g.SHOW);if(!o&&n.which!==c||o&&n.which===c){if(n.which===c){var r=t(i).find(p.DATA_TOGGLE)[0];t(r).trigger("focus")}return void t(this).trigger("click")}var s=t(i).find(p.VISIBLE_ITEMS).get();if(s.length){var a=s.indexOf(n.target);n.which===u&&a>0&&a--,n.which===d&&a<s.length-1&&a++,a<0&&(a=0),s[a].focus()}}},o(e,null,[{key:"VERSION",get:function(){return i}}]),e}();return t(document).on(_.KEYDOWN_DATA_API,p.DATA_TOGGLE,m._dataApiKeydownHandler).on(_.KEYDOWN_DATA_API,p.ROLE_MENU,m._dataApiKeydownHandler).on(_.KEYDOWN_DATA_API,p.ROLE_LISTBOX,m._dataApiKeydownHandler).on(_.CLICK_DATA_API+" "+_.FOCUSIN_DATA_API,m._clearMenus).on(_.CLICK_DATA_API,p.DATA_TOGGLE,m.prototype.toggle).on(_.CLICK_DATA_API,p.FORM_CHILD,function(t){t.stopPropagation()}),t.fn[e]=m._jQueryInterface,t.fn[e].Constructor=m,t.fn[e].noConflict=function(){return t.fn[e]=h,m._jQueryInterface},m}(jQuery),function(t){var e="modal",s="4.0.0-alpha.6",a="bs.modal",l="."+a,h=".data-api",c=t.fn[e],u=300,d=150,f=27,_={backdrop:!0,keyboard:!0,focus:!0,show:!0},g={backdrop:"(boolean|string)",keyboard:"boolean",focus:"boolean",show:"boolean"},p={HIDE:"hide"+l,HIDDEN:"hidden"+l,SHOW:"show"+l,SHOWN:"shown"+l,FOCUSIN:"focusin"+l,RESIZE:"resize"+l,CLICK_DISMISS:"click.dismiss"+l,KEYDOWN_DISMISS:"keydown.dismiss"+l,MOUSEUP_DISMISS:"mouseup.dismiss"+l,MOUSEDOWN_DISMISS:"mousedown.dismiss"+l,CLICK_DATA_API:"click"+l+h},m={SCROLLBAR_MEASURER:"modal-scrollbar-measure",BACKDROP:"modal-backdrop",OPEN:"modal-open",FADE:"fade",SHOW:"show"},E={DIALOG:".modal-dialog",DATA_TOGGLE:'[data-toggle="modal"]',DATA_DISMISS:'[data-dismiss="modal"]',FIXED_CONTENT:".fixed-top, .fixed-bottom, .is-fixed, .sticky-top"},v=function(){function h(e,i){n(this,h),this._config=this._getConfig(i),this._element=e,this._dialog=t(e).find(E.DIALOG)[0],this._backdrop=null,this._isShown=!1,this._isBodyOverflowing=!1,this._ignoreBackdropClick=!1,this._isTransitioning=!1,this._originalBodyPadding=0,this._scrollbarWidth=0}return h.prototype.toggle=function(t){return this._isShown?this.hide():this.show(t)},h.prototype.show=function(e){var n=this;if(this._isTransitioning)throw new Error("Modal is transitioning");r.supportsTransitionEnd()&&t(this._element).hasClass(m.FADE)&&(this._isTransitioning=!0);var i=t.Event(p.SHOW,{relatedTarget:e});t(this._element).trigger(i),this._isShown||i.isDefaultPrevented()||(this._isShown=!0,this._checkScrollbar(),this._setScrollbar(),t(document.body).addClass(m.OPEN),this._setEscapeEvent(),this._setResizeEvent(),t(this._element).on(p.CLICK_DISMISS,E.DATA_DISMISS,function(t){return n.hide(t)}),t(this._dialog).on(p.MOUSEDOWN_DISMISS,function(){t(n._element).one(p.MOUSEUP_DISMISS,function(e){t(e.target).is(n._element)&&(n._ignoreBackdropClick=!0)})}),this._showBackdrop(function(){return n._showElement(e)}))},h.prototype.hide=function(e){var n=this;if(e&&e.preventDefault(),this._isTransitioning)throw new Error("Modal is transitioning");var i=r.supportsTransitionEnd()&&t(this._element).hasClass(m.FADE);i&&(this._isTransitioning=!0);var o=t.Event(p.HIDE);t(this._element).trigger(o),this._isShown&&!o.isDefaultPrevented()&&(this._isShown=!1,this._setEscapeEvent(),this._setResizeEvent(),t(document).off(p.FOCUSIN),t(this._element).removeClass(m.SHOW),t(this._element).off(p.CLICK_DISMISS),t(this._dialog).off(p.MOUSEDOWN_DISMISS),i?t(this._element).one(r.TRANSITION_END,function(t){return n._hideModal(t)}).emulateTransitionEnd(u):this._hideModal())},h.prototype.dispose=function(){t.removeData(this._element,a),t(window,document,this._element,this._backdrop).off(l),this._config=null,this._element=null,this._dialog=null,this._backdrop=null,this._isShown=null,this._isBodyOverflowing=null,this._ignoreBackdropClick=null,this._originalBodyPadding=null,this._scrollbarWidth=null},h.prototype._getConfig=function(n){return n=t.extend({},_,n),r.typeCheckConfig(e,n,g),n},h.prototype._showElement=function(e){var n=this,i=r.supportsTransitionEnd()&&t(this._element).hasClass(m.FADE);this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE||document.body.appendChild(this._element),this._element.style.display="block",this._element.removeAttribute("aria-hidden"),this._element.scrollTop=0,i&&r.reflow(this._element),t(this._element).addClass(m.SHOW),this._config.focus&&this._enforceFocus();var o=t.Event(p.SHOWN,{relatedTarget:e}),s=function(){n._config.focus&&n._element.focus(),n._isTransitioning=!1,t(n._element).trigger(o)};i?t(this._dialog).one(r.TRANSITION_END,s).emulateTransitionEnd(u):s()},h.prototype._enforceFocus=function(){var e=this;t(document).off(p.FOCUSIN).on(p.FOCUSIN,function(n){document===n.target||e._element===n.target||t(e._element).has(n.target).length||e._element.focus()})},h.prototype._setEscapeEvent=function(){var e=this;this._isShown&&this._config.keyboard?t(this._element).on(p.KEYDOWN_DISMISS,function(t){t.which===f&&e.hide()}):this._isShown||t(this._element).off(p.KEYDOWN_DISMISS)},h.prototype._setResizeEvent=function(){var e=this;this._isShown?t(window).on(p.RESIZE,function(t){return e._handleUpdate(t)}):t(window).off(p.RESIZE)},h.prototype._hideModal=function(){var e=this;this._element.style.display="none",this._element.setAttribute("aria-hidden","true"),this._isTransitioning=!1,this._showBackdrop(function(){t(document.body).removeClass(m.OPEN),e._resetAdjustments(),e._resetScrollbar(),t(e._element).trigger(p.HIDDEN)})},h.prototype._removeBackdrop=function(){this._backdrop&&(t(this._backdrop).remove(),this._backdrop=null)},h.prototype._showBackdrop=function(e){var n=this,i=t(this._element).hasClass(m.FADE)?m.FADE:"";if(this._isShown&&this._config.backdrop){var o=r.supportsTransitionEnd()&&i;if(this._backdrop=document.createElement("div"),this._backdrop.className=m.BACKDROP,i&&t(this._backdrop).addClass(i),t(this._backdrop).appendTo(document.body),t(this._element).on(p.CLICK_DISMISS,function(t){return n._ignoreBackdropClick?void(n._ignoreBackdropClick=!1):void(t.target===t.currentTarget&&("static"===n._config.backdrop?n._element.focus():n.hide()))}),o&&r.reflow(this._backdrop),t(this._backdrop).addClass(m.SHOW),!e)return;if(!o)return void e();t(this._backdrop).one(r.TRANSITION_END,e).emulateTransitionEnd(d)}else if(!this._isShown&&this._backdrop){t(this._backdrop).removeClass(m.SHOW);var s=function(){n._removeBackdrop(),e&&e()};r.supportsTransitionEnd()&&t(this._element).hasClass(m.FADE)?t(this._backdrop).one(r.TRANSITION_END,s).emulateTransitionEnd(d):s()}else e&&e()},h.prototype._handleUpdate=function(){this._adjustDialog()},h.prototype._adjustDialog=function(){var t=this._element.scrollHeight>document.documentElement.clientHeight;!this._isBodyOverflowing&&t&&(this._element.style.paddingLeft=this._scrollbarWidth+"px"),this._isBodyOverflowing&&!t&&(this._element.style.paddingRight=this._scrollbarWidth+"px")},h.prototype._resetAdjustments=function(){this._element.style.paddingLeft="",this._element.style.paddingRight=""},h.prototype._checkScrollbar=function(){this._isBodyOverflowing=document.body.clientWidth<window.innerWidth,this._scrollbarWidth=this._getScrollbarWidth()},h.prototype._setScrollbar=function(){var e=parseInt(t(E.FIXED_CONTENT).css("padding-right")||0,10);this._originalBodyPadding=document.body.style.paddingRight||"",this._isBodyOverflowing&&(document.body.style.paddingRight=e+this._scrollbarWidth+"px")},h.prototype._resetScrollbar=function(){document.body.style.paddingRight=this._originalBodyPadding},h.prototype._getScrollbarWidth=function(){var t=document.createElement("div");t.className=m.SCROLLBAR_MEASURER,document.body.appendChild(t);var e=t.offsetWidth-t.clientWidth;return document.body.removeChild(t),e},h._jQueryInterface=function(e,n){return this.each(function(){var o=t(this).data(a),r=t.extend({},h.Default,t(this).data(),"object"===("undefined"==typeof e?"undefined":i(e))&&e);if(o||(o=new h(this,r),t(this).data(a,o)),"string"==typeof e){if(void 0===o[e])throw new Error('No method named "'+e+'"');o[e](n)}else r.show&&o.show(n)})},o(h,null,[{key:"VERSION",get:function(){return s}},{key:"Default",get:function(){return _}}]),h}();return t(document).on(p.CLICK_DATA_API,E.DATA_TOGGLE,function(e){var n=this,i=void 0,o=r.getSelectorFromElement(this);o&&(i=t(o)[0]);var s=t(i).data(a)?"toggle":t.extend({},t(i).data(),t(this).data());"A"!==this.tagName&&"AREA"!==this.tagName||e.preventDefault();var l=t(i).one(p.SHOW,function(e){e.isDefaultPrevented()||l.one(p.HIDDEN,function(){t(n).is(":visible")&&n.focus()})});v._jQueryInterface.call(t(i),s,this)}),t.fn[e]=v._jQueryInterface,t.fn[e].Constructor=v,t.fn[e].noConflict=function(){return t.fn[e]=c,v._jQueryInterface},v}(jQuery),function(t){var e="scrollspy",s="4.0.0-alpha.6",a="bs.scrollspy",l="."+a,h=".data-api",c=t.fn[e],u={offset:10,method:"auto",target:""},d={offset:"number",method:"string",target:"(string|element)"},f={ACTIVATE:"activate"+l,SCROLL:"scroll"+l,LOAD_DATA_API:"load"+l+h},_={DROPDOWN_ITEM:"dropdown-item",DROPDOWN_MENU:"dropdown-menu",NAV_LINK:"nav-link",NAV:"nav",ACTIVE:"active"},g={DATA_SPY:'[data-spy="scroll"]',ACTIVE:".active",LIST_ITEM:".list-item",LI:"li",LI_DROPDOWN:"li.dropdown",NAV_LINKS:".nav-link",DROPDOWN:".dropdown",DROPDOWN_ITEMS:".dropdown-item",DROPDOWN_TOGGLE:".dropdown-toggle"},p={OFFSET:"offset",POSITION:"position"},m=function(){function h(e,i){var o=this;n(this,h),this._element=e,this._scrollElement="BODY"===e.tagName?window:e,this._config=this._getConfig(i),this._selector=this._config.target+" "+g.NAV_LINKS+","+(this._config.target+" "+g.DROPDOWN_ITEMS),this._offsets=[],this._targets=[],this._activeTarget=null,this._scrollHeight=0,t(this._scrollElement).on(f.SCROLL,function(t){return o._process(t)}),this.refresh(),this._process()}return h.prototype.refresh=function(){var e=this,n=this._scrollElement!==this._scrollElement.window?p.POSITION:p.OFFSET,i="auto"===this._config.method?n:this._config.method,o=i===p.POSITION?this._getScrollTop():0;this._offsets=[],this._targets=[],this._scrollHeight=this._getScrollHeight();var s=t.makeArray(t(this._selector));s.map(function(e){var n=void 0,s=r.getSelectorFromElement(e);return s&&(n=t(s)[0]),n&&(n.offsetWidth||n.offsetHeight)?[t(n)[i]().top+o,s]:null}).filter(function(t){return t}).sort(function(t,e){return t[0]-e[0]}).forEach(function(t){e._offsets.push(t[0]),e._targets.push(t[1])})},h.prototype.dispose=function(){t.removeData(this._element,a),t(this._scrollElement).off(l),this._element=null,this._scrollElement=null,this._config=null,this._selector=null,this._offsets=null,this._targets=null,this._activeTarget=null,this._scrollHeight=null},h.prototype._getConfig=function(n){if(n=t.extend({},u,n),"string"!=typeof n.target){var i=t(n.target).attr("id");i||(i=r.getUID(e),t(n.target).attr("id",i)),n.target="#"+i}return r.typeCheckConfig(e,n,d),n},h.prototype._getScrollTop=function(){return this._scrollElement===window?this._scrollElement.pageYOffset:this._scrollElement.scrollTop},h.prototype._getScrollHeight=function(){return this._scrollElement.scrollHeight||Math.max(document.body.scrollHeight,document.documentElement.scrollHeight)},h.prototype._getOffsetHeight=function(){return this._scrollElement===window?window.innerHeight:this._scrollElement.offsetHeight},h.prototype._process=function(){var t=this._getScrollTop()+this._config.offset,e=this._getScrollHeight(),n=this._config.offset+e-this._getOffsetHeight();if(this._scrollHeight!==e&&this.refresh(),t>=n){var i=this._targets[this._targets.length-1];return void(this._activeTarget!==i&&this._activate(i))}if(this._activeTarget&&t<this._offsets[0]&&this._offsets[0]>0)return this._activeTarget=null,void this._clear();for(var o=this._offsets.length;o--;){var r=this._activeTarget!==this._targets[o]&&t>=this._offsets[o]&&(void 0===this._offsets[o+1]||t<this._offsets[o+1]);r&&this._activate(this._targets[o])}},h.prototype._activate=function(e){this._activeTarget=e,this._clear();var n=this._selector.split(",");n=n.map(function(t){return t+'[data-target="'+e+'"],'+(t+'[href="'+e+'"]')});var i=t(n.join(","));i.hasClass(_.DROPDOWN_ITEM)?(i.closest(g.DROPDOWN).find(g.DROPDOWN_TOGGLE).addClass(_.ACTIVE),i.addClass(_.ACTIVE)):i.parents(g.LI).find("> "+g.NAV_LINKS).addClass(_.ACTIVE),t(this._scrollElement).trigger(f.ACTIVATE,{relatedTarget:e})},h.prototype._clear=function(){t(this._selector).filter(g.ACTIVE).removeClass(_.ACTIVE)},h._jQueryInterface=function(e){return this.each(function(){var n=t(this).data(a),o="object"===("undefined"==typeof e?"undefined":i(e))&&e;
if(n||(n=new h(this,o),t(this).data(a,n)),"string"==typeof e){if(void 0===n[e])throw new Error('No method named "'+e+'"');n[e]()}})},o(h,null,[{key:"VERSION",get:function(){return s}},{key:"Default",get:function(){return u}}]),h}();return t(window).on(f.LOAD_DATA_API,function(){for(var e=t.makeArray(t(g.DATA_SPY)),n=e.length;n--;){var i=t(e[n]);m._jQueryInterface.call(i,i.data())}}),t.fn[e]=m._jQueryInterface,t.fn[e].Constructor=m,t.fn[e].noConflict=function(){return t.fn[e]=c,m._jQueryInterface},m}(jQuery),function(t){var e="tab",i="4.0.0-alpha.6",s="bs.tab",a="."+s,l=".data-api",h=t.fn[e],c=150,u={HIDE:"hide"+a,HIDDEN:"hidden"+a,SHOW:"show"+a,SHOWN:"shown"+a,CLICK_DATA_API:"click"+a+l},d={DROPDOWN_MENU:"dropdown-menu",ACTIVE:"active",DISABLED:"disabled",FADE:"fade",SHOW:"show"},f={A:"a",LI:"li",DROPDOWN:".dropdown",LIST:"ul:not(.dropdown-menu), ol:not(.dropdown-menu), nav:not(.dropdown-menu)",FADE_CHILD:"> .nav-item .fade, > .fade",ACTIVE:".active",ACTIVE_CHILD:"> .nav-item > .active, > .active",DATA_TOGGLE:'[data-toggle="tab"], [data-toggle="pill"]',DROPDOWN_TOGGLE:".dropdown-toggle",DROPDOWN_ACTIVE_CHILD:"> .dropdown-menu .active"},_=function(){function e(t){n(this,e),this._element=t}return e.prototype.show=function(){var e=this;if(!(this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE&&t(this._element).hasClass(d.ACTIVE)||t(this._element).hasClass(d.DISABLED))){var n=void 0,i=void 0,o=t(this._element).closest(f.LIST)[0],s=r.getSelectorFromElement(this._element);o&&(i=t.makeArray(t(o).find(f.ACTIVE)),i=i[i.length-1]);var a=t.Event(u.HIDE,{relatedTarget:this._element}),l=t.Event(u.SHOW,{relatedTarget:i});if(i&&t(i).trigger(a),t(this._element).trigger(l),!l.isDefaultPrevented()&&!a.isDefaultPrevented()){s&&(n=t(s)[0]),this._activate(this._element,o);var h=function(){var n=t.Event(u.HIDDEN,{relatedTarget:e._element}),o=t.Event(u.SHOWN,{relatedTarget:i});t(i).trigger(n),t(e._element).trigger(o)};n?this._activate(n,n.parentNode,h):h()}}},e.prototype.dispose=function(){t.removeClass(this._element,s),this._element=null},e.prototype._activate=function(e,n,i){var o=this,s=t(n).find(f.ACTIVE_CHILD)[0],a=i&&r.supportsTransitionEnd()&&(s&&t(s).hasClass(d.FADE)||Boolean(t(n).find(f.FADE_CHILD)[0])),l=function(){return o._transitionComplete(e,s,a,i)};s&&a?t(s).one(r.TRANSITION_END,l).emulateTransitionEnd(c):l(),s&&t(s).removeClass(d.SHOW)},e.prototype._transitionComplete=function(e,n,i,o){if(n){t(n).removeClass(d.ACTIVE);var s=t(n.parentNode).find(f.DROPDOWN_ACTIVE_CHILD)[0];s&&t(s).removeClass(d.ACTIVE),n.setAttribute("aria-expanded",!1)}if(t(e).addClass(d.ACTIVE),e.setAttribute("aria-expanded",!0),i?(r.reflow(e),t(e).addClass(d.SHOW)):t(e).removeClass(d.FADE),e.parentNode&&t(e.parentNode).hasClass(d.DROPDOWN_MENU)){var a=t(e).closest(f.DROPDOWN)[0];a&&t(a).find(f.DROPDOWN_TOGGLE).addClass(d.ACTIVE),e.setAttribute("aria-expanded",!0)}o&&o()},e._jQueryInterface=function(n){return this.each(function(){var i=t(this),o=i.data(s);if(o||(o=new e(this),i.data(s,o)),"string"==typeof n){if(void 0===o[n])throw new Error('No method named "'+n+'"');o[n]()}})},o(e,null,[{key:"VERSION",get:function(){return i}}]),e}();return t(document).on(u.CLICK_DATA_API,f.DATA_TOGGLE,function(e){e.preventDefault(),_._jQueryInterface.call(t(this),"show")}),t.fn[e]=_._jQueryInterface,t.fn[e].Constructor=_,t.fn[e].noConflict=function(){return t.fn[e]=h,_._jQueryInterface},_}(jQuery),function(t){if("undefined"==typeof Tether)throw new Error("Bootstrap tooltips require Tether (http://tether.io/)");var e="tooltip",s="4.0.0-alpha.6",a="bs.tooltip",l="."+a,h=t.fn[e],c=150,u="bs-tether",d={animation:!0,template:'<div class="tooltip" role="tooltip"><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,selector:!1,placement:"top",offset:"0 0",constraints:[],container:!1},f={animation:"boolean",template:"string",title:"(string|element|function)",trigger:"string",delay:"(number|object)",html:"boolean",selector:"(string|boolean)",placement:"(string|function)",offset:"string",constraints:"array",container:"(string|element|boolean)"},_={TOP:"bottom center",RIGHT:"middle left",BOTTOM:"top center",LEFT:"middle right"},g={SHOW:"show",OUT:"out"},p={HIDE:"hide"+l,HIDDEN:"hidden"+l,SHOW:"show"+l,SHOWN:"shown"+l,INSERTED:"inserted"+l,CLICK:"click"+l,FOCUSIN:"focusin"+l,FOCUSOUT:"focusout"+l,MOUSEENTER:"mouseenter"+l,MOUSELEAVE:"mouseleave"+l},m={FADE:"fade",SHOW:"show"},E={TOOLTIP:".tooltip",TOOLTIP_INNER:".tooltip-inner"},v={element:!1,enabled:!1},T={HOVER:"hover",FOCUS:"focus",CLICK:"click",MANUAL:"manual"},I=function(){function h(t,e){n(this,h),this._isEnabled=!0,this._timeout=0,this._hoverState="",this._activeTrigger={},this._isTransitioning=!1,this._tether=null,this.element=t,this.config=this._getConfig(e),this.tip=null,this._setListeners()}return h.prototype.enable=function(){this._isEnabled=!0},h.prototype.disable=function(){this._isEnabled=!1},h.prototype.toggleEnabled=function(){this._isEnabled=!this._isEnabled},h.prototype.toggle=function(e){if(e){var n=this.constructor.DATA_KEY,i=t(e.currentTarget).data(n);i||(i=new this.constructor(e.currentTarget,this._getDelegateConfig()),t(e.currentTarget).data(n,i)),i._activeTrigger.click=!i._activeTrigger.click,i._isWithActiveTrigger()?i._enter(null,i):i._leave(null,i)}else{if(t(this.getTipElement()).hasClass(m.SHOW))return void this._leave(null,this);this._enter(null,this)}},h.prototype.dispose=function(){clearTimeout(this._timeout),this.cleanupTether(),t.removeData(this.element,this.constructor.DATA_KEY),t(this.element).off(this.constructor.EVENT_KEY),t(this.element).closest(".modal").off("hide.bs.modal"),this.tip&&t(this.tip).remove(),this._isEnabled=null,this._timeout=null,this._hoverState=null,this._activeTrigger=null,this._tether=null,this.element=null,this.config=null,this.tip=null},h.prototype.show=function(){var e=this;if("none"===t(this.element).css("display"))throw new Error("Please use show on visible elements");var n=t.Event(this.constructor.Event.SHOW);if(this.isWithContent()&&this._isEnabled){if(this._isTransitioning)throw new Error("Tooltip is transitioning");t(this.element).trigger(n);var i=t.contains(this.element.ownerDocument.documentElement,this.element);if(n.isDefaultPrevented()||!i)return;var o=this.getTipElement(),s=r.getUID(this.constructor.NAME);o.setAttribute("id",s),this.element.setAttribute("aria-describedby",s),this.setContent(),this.config.animation&&t(o).addClass(m.FADE);var a="function"==typeof this.config.placement?this.config.placement.call(this,o,this.element):this.config.placement,l=this._getAttachment(a),c=this.config.container===!1?document.body:t(this.config.container);t(o).data(this.constructor.DATA_KEY,this).appendTo(c),t(this.element).trigger(this.constructor.Event.INSERTED),this._tether=new Tether({attachment:l,element:o,target:this.element,classes:v,classPrefix:u,offset:this.config.offset,constraints:this.config.constraints,addTargetClasses:!1}),r.reflow(o),this._tether.position(),t(o).addClass(m.SHOW);var d=function(){var n=e._hoverState;e._hoverState=null,e._isTransitioning=!1,t(e.element).trigger(e.constructor.Event.SHOWN),n===g.OUT&&e._leave(null,e)};if(r.supportsTransitionEnd()&&t(this.tip).hasClass(m.FADE))return this._isTransitioning=!0,void t(this.tip).one(r.TRANSITION_END,d).emulateTransitionEnd(h._TRANSITION_DURATION);d()}},h.prototype.hide=function(e){var n=this,i=this.getTipElement(),o=t.Event(this.constructor.Event.HIDE);if(this._isTransitioning)throw new Error("Tooltip is transitioning");var s=function(){n._hoverState!==g.SHOW&&i.parentNode&&i.parentNode.removeChild(i),n.element.removeAttribute("aria-describedby"),t(n.element).trigger(n.constructor.Event.HIDDEN),n._isTransitioning=!1,n.cleanupTether(),e&&e()};t(this.element).trigger(o),o.isDefaultPrevented()||(t(i).removeClass(m.SHOW),this._activeTrigger[T.CLICK]=!1,this._activeTrigger[T.FOCUS]=!1,this._activeTrigger[T.HOVER]=!1,r.supportsTransitionEnd()&&t(this.tip).hasClass(m.FADE)?(this._isTransitioning=!0,t(i).one(r.TRANSITION_END,s).emulateTransitionEnd(c)):s(),this._hoverState="")},h.prototype.isWithContent=function(){return Boolean(this.getTitle())},h.prototype.getTipElement=function(){return this.tip=this.tip||t(this.config.template)[0]},h.prototype.setContent=function(){var e=t(this.getTipElement());this.setElementContent(e.find(E.TOOLTIP_INNER),this.getTitle()),e.removeClass(m.FADE+" "+m.SHOW),this.cleanupTether()},h.prototype.setElementContent=function(e,n){var o=this.config.html;"object"===("undefined"==typeof n?"undefined":i(n))&&(n.nodeType||n.jquery)?o?t(n).parent().is(e)||e.empty().append(n):e.text(t(n).text()):e[o?"html":"text"](n)},h.prototype.getTitle=function(){var t=this.element.getAttribute("data-original-title");return t||(t="function"==typeof this.config.title?this.config.title.call(this.element):this.config.title),t},h.prototype.cleanupTether=function(){this._tether&&this._tether.destroy()},h.prototype._getAttachment=function(t){return _[t.toUpperCase()]},h.prototype._setListeners=function(){var e=this,n=this.config.trigger.split(" ");n.forEach(function(n){if("click"===n)t(e.element).on(e.constructor.Event.CLICK,e.config.selector,function(t){return e.toggle(t)});else if(n!==T.MANUAL){var i=n===T.HOVER?e.constructor.Event.MOUSEENTER:e.constructor.Event.FOCUSIN,o=n===T.HOVER?e.constructor.Event.MOUSELEAVE:e.constructor.Event.FOCUSOUT;t(e.element).on(i,e.config.selector,function(t){return e._enter(t)}).on(o,e.config.selector,function(t){return e._leave(t)})}t(e.element).closest(".modal").on("hide.bs.modal",function(){return e.hide()})}),this.config.selector?this.config=t.extend({},this.config,{trigger:"manual",selector:""}):this._fixTitle()},h.prototype._fixTitle=function(){var t=i(this.element.getAttribute("data-original-title"));(this.element.getAttribute("title")||"string"!==t)&&(this.element.setAttribute("data-original-title",this.element.getAttribute("title")||""),this.element.setAttribute("title",""))},h.prototype._enter=function(e,n){var i=this.constructor.DATA_KEY;return n=n||t(e.currentTarget).data(i),n||(n=new this.constructor(e.currentTarget,this._getDelegateConfig()),t(e.currentTarget).data(i,n)),e&&(n._activeTrigger["focusin"===e.type?T.FOCUS:T.HOVER]=!0),t(n.getTipElement()).hasClass(m.SHOW)||n._hoverState===g.SHOW?void(n._hoverState=g.SHOW):(clearTimeout(n._timeout),n._hoverState=g.SHOW,n.config.delay&&n.config.delay.show?void(n._timeout=setTimeout(function(){n._hoverState===g.SHOW&&n.show()},n.config.delay.show)):void n.show())},h.prototype._leave=function(e,n){var i=this.constructor.DATA_KEY;if(n=n||t(e.currentTarget).data(i),n||(n=new this.constructor(e.currentTarget,this._getDelegateConfig()),t(e.currentTarget).data(i,n)),e&&(n._activeTrigger["focusout"===e.type?T.FOCUS:T.HOVER]=!1),!n._isWithActiveTrigger())return clearTimeout(n._timeout),n._hoverState=g.OUT,n.config.delay&&n.config.delay.hide?void(n._timeout=setTimeout(function(){n._hoverState===g.OUT&&n.hide()},n.config.delay.hide)):void n.hide()},h.prototype._isWithActiveTrigger=function(){for(var t in this._activeTrigger)if(this._activeTrigger[t])return!0;return!1},h.prototype._getConfig=function(n){return n=t.extend({},this.constructor.Default,t(this.element).data(),n),n.delay&&"number"==typeof n.delay&&(n.delay={show:n.delay,hide:n.delay}),r.typeCheckConfig(e,n,this.constructor.DefaultType),n},h.prototype._getDelegateConfig=function(){var t={};if(this.config)for(var e in this.config)this.constructor.Default[e]!==this.config[e]&&(t[e]=this.config[e]);return t},h._jQueryInterface=function(e){return this.each(function(){var n=t(this).data(a),o="object"===("undefined"==typeof e?"undefined":i(e))&&e;if((n||!/dispose|hide/.test(e))&&(n||(n=new h(this,o),t(this).data(a,n)),"string"==typeof e)){if(void 0===n[e])throw new Error('No method named "'+e+'"');n[e]()}})},o(h,null,[{key:"VERSION",get:function(){return s}},{key:"Default",get:function(){return d}},{key:"NAME",get:function(){return e}},{key:"DATA_KEY",get:function(){return a}},{key:"Event",get:function(){return p}},{key:"EVENT_KEY",get:function(){return l}},{key:"DefaultType",get:function(){return f}}]),h}();return t.fn[e]=I._jQueryInterface,t.fn[e].Constructor=I,t.fn[e].noConflict=function(){return t.fn[e]=h,I._jQueryInterface},I}(jQuery));(function(r){var a="popover",l="4.0.0-alpha.6",h="bs.popover",c="."+h,u=r.fn[a],d=r.extend({},s.Default,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),f=r.extend({},s.DefaultType,{content:"(string|element|function)"}),_={FADE:"fade",SHOW:"show"},g={TITLE:".popover-title",CONTENT:".popover-content"},p={HIDE:"hide"+c,HIDDEN:"hidden"+c,SHOW:"show"+c,SHOWN:"shown"+c,INSERTED:"inserted"+c,CLICK:"click"+c,FOCUSIN:"focusin"+c,FOCUSOUT:"focusout"+c,MOUSEENTER:"mouseenter"+c,MOUSELEAVE:"mouseleave"+c},m=function(s){function u(){return n(this,u),t(this,s.apply(this,arguments))}return e(u,s),u.prototype.isWithContent=function(){return this.getTitle()||this._getContent()},u.prototype.getTipElement=function(){return this.tip=this.tip||r(this.config.template)[0]},u.prototype.setContent=function(){var t=r(this.getTipElement());this.setElementContent(t.find(g.TITLE),this.getTitle()),this.setElementContent(t.find(g.CONTENT),this._getContent()),t.removeClass(_.FADE+" "+_.SHOW),this.cleanupTether()},u.prototype._getContent=function(){return this.element.getAttribute("data-content")||("function"==typeof this.config.content?this.config.content.call(this.element):this.config.content)},u._jQueryInterface=function(t){return this.each(function(){var e=r(this).data(h),n="object"===("undefined"==typeof t?"undefined":i(t))?t:null;if((e||!/destroy|hide/.test(t))&&(e||(e=new u(this,n),r(this).data(h,e)),"string"==typeof t)){if(void 0===e[t])throw new Error('No method named "'+t+'"');e[t]()}})},o(u,null,[{key:"VERSION",get:function(){return l}},{key:"Default",get:function(){return d}},{key:"NAME",get:function(){return a}},{key:"DATA_KEY",get:function(){return h}},{key:"Event",get:function(){return p}},{key:"EVENT_KEY",get:function(){return c}},{key:"DefaultType",get:function(){return f}}]),u}(s);return r.fn[a]=m._jQueryInterface,r.fn[a].Constructor=m,r.fn[a].noConflict=function(){return r.fn[a]=u,m._jQueryInterface},m})(jQuery)}();
(function ($) {

  var methods = {
    init : function(options) {
      var defaults = {
        menuWidth: 240,
        edge: 'left',
        closeOnClick: false
      };
      options = $.extend(defaults, options);

      $(this).each(function(){
        var $this = $(this);
        var menu_id = $("#"+ $this.attr('data-activates'));

        // Set to width
        if (options.menuWidth != 240) {
          menu_id.css('width', options.menuWidth);
        }

        // Add Touch Area
        var dragTarget = $('<div class="drag-target"></div>');
        $('body').append(dragTarget);

        if (options.edge == 'left') {
          menu_id.css('transform', 'translateX(-100%)');
          dragTarget.css({'left': 0}); // Add Touch Area
        }
        else {
          menu_id.addClass('right-aligned') // Change text-alignment to right
            .css('transform', 'translateX(100%)');
          dragTarget.css({'right': 0}); // Add Touch Area
        }

        // If fixed sidenav, bring menu out
        if (menu_id.hasClass('fixed')) {
            if (window.innerWidth > 1440) {
              menu_id.css('transform', 'translateX(0)');
            }
          }

        // Window resize to reset on large screens fixed
        if (menu_id.hasClass('fixed')) {
          $(window).resize( function() {
            if (window.innerWidth > 1440) {
              // Close menu if window is resized bigger than 992 and user has fixed sidenav
              if ($('#sidenav-overlay').length != 0 && menuOut) {
                removeMenu(true);
              }
              else {
                // menu_id.removeAttr('style');
                menu_id.css('transform', 'translateX(0%)');
                // menu_id.css('width', options.menuWidth);
              }
            }
            else if (menuOut === false){
              if (options.edge === 'left') {
                menu_id.css('transform', 'translateX(-100%)');
              } else {
                menu_id.css('transform', 'translateX(100%)');
              }

            }

          });
        }

        // if closeOnClick, then add close event for all a tags in side sideNav
        if (options.closeOnClick === true) {
          menu_id.on("click.itemclick", "a:not(.collapsible-header)", function(){
            removeMenu();
          });
        }

        function removeMenu(restoreNav) {
          panning = false;
          menuOut = false;
          // Reenable scrolling
          $('body').css({
            overflow: '',
            width: ''
          });

          $('#sidenav-overlay').velocity({opacity: 0}, {duration: 200,
              queue: false, easing: 'easeOutQuad',
            complete: function() {
              $(this).remove();
            } });
          if (options.edge === 'left') {
            // Reset phantom div
            dragTarget.css({width: '', right: '', left: '0'});
            menu_id.velocity(
              {'translateX': '-100%'},
              { duration: 200,
                queue: false,
                easing: 'easeOutCubic',
                complete: function() {
                  if (restoreNav === true) {
                    // Restore Fixed sidenav
                    menu_id.removeAttr('style');
                    menu_id.css('width', options.menuWidth);
                  }
                }

            });
          }
          else {
            // Reset phantom div
            dragTarget.css({width: '', right: '0', left: ''});
            menu_id.velocity(
              {'translateX': '100%'},
              { duration: 200,
                queue: false,
                easing: 'easeOutCubic',
                complete: function() {
                  if (restoreNav === true) {
                    // Restore Fixed sidenav
                    menu_id.removeAttr('style');
                    menu_id.css('width', options.menuWidth);
                  }
                }
              });
          }
        }



        // Touch Event
        var panning = false;
        var menuOut = false;

        dragTarget.on('click', function(){
          removeMenu();
        });

        dragTarget.hammer({
          prevent_default: false
        }).bind('pan', function(e) {

          if (e.gesture.pointerType == "touch") {

            var direction = e.gesture.direction;
            var x = e.gesture.center.x;
            var y = e.gesture.center.y;
            var velocityX = e.gesture.velocityX;

            // Disable Scrolling
            var $body = $('body');
            var oldWidth = $body.innerWidth();
            $body.css('overflow', 'hidden');
            $body.width(oldWidth);

            // If overlay does not exist, create one and if it is clicked, close menu
            if ($('#sidenav-overlay').length === 0) {
              var overlay = $('<div id="sidenav-overlay"></div>');
              overlay.css('opacity', 0).click( function(){
                removeMenu();
              });
              $('body').append(overlay);
            }

            // Keep within boundaries
            if (options.edge === 'left') {
              if (x > options.menuWidth) { x = options.menuWidth; }
              else if (x < 0) { x = 0; }
            }

            if (options.edge === 'left') {
              // Left Direction
              if (x < (options.menuWidth / 2)) { menuOut = false; }
              // Right Direction
              else if (x >= (options.menuWidth / 2)) { menuOut = true; }
              menu_id.css('transform', 'translateX(' + (x - options.menuWidth) + 'px)');
            }
            else {
              // Left Direction
              if (x < (window.innerWidth - options.menuWidth / 2)) {
                menuOut = true;
              }
              // Right Direction
              else if (x >= (window.innerWidth - options.menuWidth / 2)) {
               menuOut = false;
             }
              var rightPos = (x - options.menuWidth / 2);
              if (rightPos < 0) {
                rightPos = 0;
              }

              menu_id.css('transform', 'translateX(' + rightPos + 'px)');
            }


            // Percentage overlay
            var overlayPerc;
            if (options.edge === 'left') {
              overlayPerc = x / options.menuWidth;
              $('#sidenav-overlay').velocity({opacity: overlayPerc }, {duration: 10, queue: false, easing: 'easeOutQuad'});
            }
            else {
              overlayPerc = Math.abs((x - window.innerWidth) / options.menuWidth);
              $('#sidenav-overlay').velocity({opacity: overlayPerc }, {duration: 10, queue: false, easing: 'easeOutQuad'});
            }
          }

        }).bind('panend', function(e) {

          if (e.gesture.pointerType == "touch") {
            var velocityX = e.gesture.velocityX;
            var x = e.gesture.center.x;
            var leftPos = x - options.menuWidth;
            var rightPos = x - options.menuWidth / 2;
            if (leftPos > 0 ) {
              leftPos = 0;
            }
            if (rightPos < 0) {
              rightPos = 0;
            }
            panning = false;

            if (options.edge === 'left') {
              // If velocityX <= 0.3 then the user is flinging the menu closed so ignore menuOut
              if ((menuOut && velocityX <= 0.3) || velocityX < -0.5) {
                if (leftPos != 0) {
                  menu_id.velocity({'translateX': [0, leftPos]}, {duration: 300, queue: false, easing: 'easeOutQuad'});
                }

                // menu_id.css({'translateX': 0});
                $('#sidenav-overlay').velocity({opacity: 1 }, {duration: 50, queue: false, easing: 'easeOutQuad'});
                dragTarget.css({width: '50%', right: 0, left: ''});
              }
              else if (!menuOut || velocityX > 0.3) {
                // Enable Scrolling
                $('body').css({
                  overflow: '',
                  width: ''
                });
                // Slide menu closed
                menu_id.velocity({'translateX': [-1 * options.menuWidth - 10, leftPos]}, {duration: 200, queue: false, easing: 'easeOutQuad'});
                $('#sidenav-overlay').velocity({opacity: 0 }, {duration: 200, queue: false, easing: 'easeOutQuad',
                  complete: function () {
                    $(this).remove();
                  }});
                dragTarget.css({width: '10px', right: '', left: 0});
              }
            }
            else {
              if ((menuOut && velocityX >= -0.3) || velocityX > 0.5) {
                menu_id.velocity({'translateX': [0, rightPos]}, {duration: 300, queue: false, easing: 'easeOutQuad'});
                $('#sidenav-overlay').velocity({opacity: 1 }, {duration: 50, queue: false, easing: 'easeOutQuad'});
                dragTarget.css({width: '50%', right: '', left: 0});
              }
              else if (!menuOut || velocityX < -0.3) {
                // Enable Scrolling
                $('body').css({
                  overflow: '',
                  width: ''
                });

                // Slide menu closed
                menu_id.velocity({'translateX': [options.menuWidth + 10, rightPos]}, {duration: 200, queue: false, easing: 'easeOutQuad'});
                $('#sidenav-overlay').velocity({opacity: 0 }, {duration: 200, queue: false, easing: 'easeOutQuad',
                  complete: function () {
                    $(this).remove();
                  }});
                dragTarget.css({width: '10px', right: 0, left: ''});
              }
            }

          }
        });

          $this.click(function() {
            if (menuOut === true) {
              menuOut = false;
              panning = false;
              removeMenu();
            }
            else {

              // Disable Scrolling
              var $body = $('body');
              var oldWidth = $body.innerWidth();
              $body.css('overflow', 'hidden');
              $body.width(oldWidth);

              // Push current drag target on top of DOM tree
              $('body').append(dragTarget);

              if (options.edge === 'left') {
                dragTarget.css({width: '50%', right: 0, left: ''});
                menu_id.velocity({'translateX': [0, -1 * options.menuWidth]}, {duration: 300, queue: false, easing: 'easeOutQuad'});
              }
              else {
                dragTarget.css({width: '50%', right: '', left: 0});
                menu_id.velocity({'translateX': [0, options.menuWidth]}, {duration: 300, queue: false, easing: 'easeOutQuad'});
              }

              var overlay = $('<div id="sidenav-overlay"></div>');
              overlay.css('opacity', 0)
              .click(function(){
                menuOut = false;
                panning = false;
                removeMenu();
                overlay.velocity({opacity: 0}, {duration: 300, queue: false, easing: 'easeOutQuad',
                  complete: function() {
                    $(this).remove();
                  } });

              });
              $('body').append(overlay);
              overlay.velocity({opacity: 1}, {duration: 300, queue: false, easing: 'easeOutQuad',
                complete: function () {
                  menuOut = true;
                  panning = false;
                }
              });
            }

            return false;
          });
      });


    },
    show : function() {
      this.trigger('click');
    },
    hide : function() {
      $('#sidenav-overlay').trigger('click');
    }
  };


    $.fn.sideNav = function(methodOrOptions) {
      if ( methods[methodOrOptions] ) {
        return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));
      } else if ( typeof methodOrOptions === 'object' || ! methodOrOptions ) {
        // Default to "init"
        return methods.init.apply( this, arguments );
      } else {
        $.error( 'Method ' +  methodOrOptions + ' does not exist on jQuery.sideNav' );
      }
    }; // Plugin end
}( jQuery ));

$(window).on("load", function() {
    $(".has-tooltip").tooltip();
    $(".button-collapse").sideNav();

    $(".stock-indicator-warehouse-grid-button").popover({
        container: "body",
        html: true,
        content: function() {
            popoverContent = $(this).parent().find(".stock-indicator-warehouse-grid").html();
            return popoverContent;
        }
    });
});

window.catalog = window.catalog || {};
catalog.alternateParts = catalog.alternateParts || [];

window.catalog.ProductPreview = function (data) {
    var self = this;

    self.exists = data.exists;
    self.warehouseId = data.warehouse_id;
    self.warehouseForUrl = data.warehouse_for_url;
    self.partNumber = data.part_number;
    self.customerPartNumber = ko.observable(data.customerPartNumber);
    self.newCustomerPartNumber = ko.observable("");
    self.slug = data.slug;
    self.cartComments = data.cartComments;
    self.partIdForUrl = data.part_id_for_url;
    self.url = data.url;
    self.upc = data.upc;
    self.title = data.title;
    self.salesDept = data.salesDept;
    self.isNew = data.new_status && data.new_status.start && data.new_status.start !== "";
    self.newAsOf = self.isNew ? data.new_status.start : "";
    self.shortDescription = data.short_description;
    self.longDescription = data.long_description;
    self.HTMLDescription = data.HTML_description;
    self.descriptionForUrl = data.description_for_url;
    self.thumbnails = data.thumbnails;
    self.defaultCategory = data.default_category;
    self.manufacturer = data.manufacturer;
    self.customFields = data.custom_fields;
    self.stock = data.stock;
    self.statuses = data.statuses;
    self.isOnSale = false;
    self.onSaleStatuses = [];
    self.price = parseFloat(data.price);
    self.priceText = "$" + data.price;
    self.list_price = parseFloat(data.list_price);
    self.listPriceText = "$" + data.list_price;
    self.qty = $('#grid-list-view-toggle-container div.list-view img.list-view-on').is(':visible') && $('div.add-all-to-cart').is(':visible') ? ko.observable("") : ko.observable(1);
    self.qtyFieldId = "qty_" + data.warehouse_id + "_" + data.part_number;
    self.qtyFieldName = "shopping_cart[add][" + data.warehouse_id + "][" + data.part_number + "][quantity]";
    self.uoms = data.uoms;
    self.defaultUom = ko.observable(data.default_uom);
    self.uomFieldName = "shopping_cart[add][" + data.warehouse_id + "][" + data.part_number + "][uom]";
    self.is_quote_only = data.is_quote_only;
    self.showAddToCartForQuotableProducts = Quote.showAddToCartForQuotableProducts;
    self.selectedUOM = ko.observable(data.default_uom);
    self.isSelectedForCompare = data.isSelectedForCompare;
    self.addons = data.addons;
    self.isDigitalProduct = data.isDigitalProduct;
    self.partDiagrams = data.partDiagrams;
    self.hasPartDiagrams = data.partDiagrams.length > 0 ? 1 : 0;
    self.packSize = data.packSize;
    self.isPriceVisible = data.isPriceVisible;
    self.isAddToCartVisible = data.isAddToCartVisible;
    self.isKittedProduct = data.isKittedProduct;
    self.reorderPoint = data.reorderPoint;
    self.minimumOrderQty = data.minimumOrderQty;
    self.promotion = data.promotion;
    self.isTrainingCourse = data.isTrainingCourse;
    self.trainingCourses = data.trainingCourses;
    self.yearToDateGrossSales = data.yearToDateGrossSales;
    self.images = data.images;
    self.orderTemplates = ko.observable();
    self.alternateParts = !_.isUndefined(data.alternate_parts) ? data.alternate_parts : [];
    self.preOrderPricing = data.preOrderPricing;
    self.productUomDisplaySetting = window.productUomDisplaySetting;
    self.favouriteData = data.favouriteData;
    self.preloadedFavourite = !_.isUndefined(data.favouriteData) && data.favouriteData.isPreloaded === "1" ? true : false;
    self.productSelectorGroup = data.productSelectorGroup;
    self.productSelectorGroupData = data.productSelectorGroupData;
    self.onlyDisplayAlternates = onlyDisplayAlternates;
    self.displayAlternateField = displayAlternateField;
    self.isOnSaleNotification = ko.observable(false);
    self.isInStockNotification = ko.observable(false);
    self.relatedFiles = _.values(data.related_files);
    self.isAddon = data.isAddon;
    self.isPurchasable = data.isPurchasable;
    self.isFavourite = data.isFavourite;
    self.equipmentRegistryDetails = !_.isUndefined(data.equipmentRegistryDetails) ? data.equipmentRegistryDetails : [];

    self.hasDiscount = function () {
        var listPrice = parseFloat(data.list_price.replace(/,/g, ""));
        var price = parseFloat(data.price.replace(/,/g, ""));

        return (listPrice > price) ? true : false;
    };

    self.outputProductStatusClasses = function () {
        var productStatus = "";
        _.forEach(self.statuses, function (status) {
            if (status.name === "on_sale") {
                productStatus = prepProductStatusClass(status.name);
            } else if (productStatus === "") {
                productStatus = prepProductStatusClass(status.name);
            }
        });

        return productStatus;
    };

    var prepProductStatusClass = function (status) {
        var classes = "product_status_icon ";
        var string = String(status).replace(/,/g, " ");

        return classes + string;
    };

    self.outputProductStatusImage = function () {
        var statusImage = "";
        _.forEach(self.statuses, function (status) {
            if (status.name === "on_sale") {
                statusImage = status.image;
            } else if (statusImage === "") {
                statusImage = status.image;
            }
        });

        return statusImage;
    };

    self.hasStatus = function (name) {
        return _.some(self.statuses, function(status) {
            return (name == status.name);
        });
    };

    self.hasManufacturer = function () {
        return self.manufacturer.id > 0;
    };

    self.hasCustomField = function (name) {
        return _.some(self.customFields, function(field) {
            return (name == field.name);
        });
    };

    self.getCustomField = function (name) {
        var customField;
        _.forEach(self.customFields, function (field) {
            if (name == field.name) {
                customField = field;
            }
        });

        return customField;
    };

    self.selectedUomObj = ko.computed(function () {
        var selectedUOM = self.selectedUOM();
        var found = null;
        $.each(self.uoms, function (k, uom) {
            if (uom.code == selectedUOM) {
                found = uom;
            }
        });

        return found;
    });

    self.showQuoteButton = ko.computed(function () {
        return _.result(_.find(self.uoms, function (uom) {
            return uom.code == self.selectedUOM();
        }), "is_quote_only");
    });

    self.canAddToCart = function () {
        var visible = self.isAddToCartVisible ? true : false;

        if (visible && self.isPriceVisible && self.selectedUomObj().price === 0) {
            visible = false;
        }

        return visible;
    };

    self.prep_alternate_parts = function (product) {
        if (product.alternate_parts !== undefined && product.alternate_parts !== null) {
            var alternateParts = product.alternate_parts;

            if (alternateParts.alts !== undefined && alternateParts.alts !== null && alternateParts.alts.length > 0) {
                catalog.alternateParts[product.slug] = alternateParts;
            }
        }
    };

    self.prep_alternate_parts(data);

    self.prepUnitsOfMeasure = function (defaultUom) {
        var unitsOfMeasure = [];
        var defaultUnitOfMeasure = null;

        _.forEach(self.uoms, function (uom) {
            if (uom.code === defaultUom) {
                uom.is_default = true;
                defaultUnitOfMeasure = uom;
            } else if (uom.isSellUom) {
                uom.is_default = false;
                unitsOfMeasure.push(uom);
            }
        });

        if (defaultUnitOfMeasure !== null) {
            unitsOfMeasure.unshift(defaultUnitOfMeasure);
        }

        self.uoms = unitsOfMeasure;
    };

    self.prepUnitsOfMeasure(data.default_uom);

    self.getImage = function (key, size) {
        return data.images[key][size];
    };

    self.defaultImage = ko.observable(self.getImage(0, "medium"));
    self.enlargeImage = ko.observable(self.getImage(0, "large"));

    self.setDetailsImage = function (index, image) {
        self.defaultImage(image);
        self.enlargeImage(self.getImage(index, "large"));
    };

    self.humanize = function (value) {
        temp = $.trim(value).toLowerCase();
        temp = temp.replace(/[_-]+/g, ' ');

        return temp.charAt(0).toUpperCase() + temp.slice(1);
    };

    self.machinize = function (value) {
        temp = $.trim(value).toLowerCase();

        return temp.replace(/\s+/g, '_');
    };

    self.buildProductRatings = function (rating) {
        var self = this;
        var fullStarsArray = [];
        var halfStarsArray = [];
        var emptyStarsArray = [];

        if (!_.isUndefined(rating) && rating != null) {
            var i = 0;

            for (i = 0; i < rating.full_stars; i++) {
                fullStarsArray[i] = i;
            }

            for (i = 0; i < rating.half_stars; i++) {
                halfStarsArray[i] = i;
            }

            for (i = 0; i < rating.empty_stars; i++) {
                emptyStarsArray[i] = i;
            }

            self.rating = {
                "averageRating": rating.average_rating,
                "reviewCount": rating.review_count,
                "maxReviewRating": rating.max_review_rating,
                "fullStars": fullStarsArray,
                "halfStars": halfStarsArray,
                "emptyStars": emptyStarsArray
            };
        }
    };

    self.buildProductRatings(data.rating);

    self.buildQuantityBreaks = function (quantityBreaks) {
        var availableRanges = [];
        var qbcount = self.findQuantityBreakCount(quantityBreaks);
        $.each(quantityBreaks, function (uom, quantityBreak) {
            var length = _.size(quantityBreak);
            var ranges = [];
            var liClass = "li_" + uom + " ";
            var divClass = "qb_" + uom + " quantity_break_container ";

            liClass += (self.defaultUom() == uom || qbcount == 1) ? "selected" : "";
            divClass += (self.defaultUom() == uom || qbcount == 1) ? " show" : " hide";

            $.each(quantityBreak, function (range, value) {
                var thisRange = {
                    "lowerBound": value.lowerBound,
                    "rangeName": range,
                    "actualPrice": value.formatted_actual_price
                };

                ranges.push(thisRange);
            });

            var thisUom = {
                "liClass": liClass,
                "divClass": divClass,
                "name": uom,
                "ranges": ranges
            };

            availableRanges.push(thisUom);
        });

        self.quantityBreaks = {
            "availableRanges": availableRanges,
            "quantityBreaksAvailable": (availableRanges.length > 0) ? true : false
        };
    };

    self.findQuantityBreakCount = function (qbs) {
        var count = 0;
        for (var k in qbs) {
            if (qbs.hasOwnProperty(k)) {
                count++;
            }
        }
        return count;
    };

    self.doesUomHaveQuantityBreaks = function() {
        return _.find(self.quantityBreaks.availableRanges, {name: self.selectedUOM()});
    };

    self.getCartCommentForUom = function () {
        return (self.selectedUOM() in self.cartComments) ? self.cartComments[self.selectedUOM()] : "";
    };

    self.buildQuantityBreaks(data.quantity_breaks);

    self.displayQuickViewModal = function () {
        $("#quick-view-modal-" + self.slug).modal("show");
    };

    self.hasValidPricing = function () {
        return self.isPriceVisible && self.price !== 0;
    };

    self.getTrainingCourseLocation = function () {
        return self.trainingCourses[0].location;
    };

    self.loadOrderTemplates = function (data) {
        slug = data.product.slug;
        orderTemplates.loadOrderTemplates(slug, data.product.selectedUOM()).done(function (data) {
            self.orderTemplates(data);
            $("#order-template-modal-" + slug).modal();
        });
    };

    self.removeFavourite = function(id, e) {
        if (confirmFavouriteDelete()) {
            $(".ajax-load-overlay").show();

            $.ajax({
                url: base_index_url + "my_account/favourites/delete",
                type: "POST",
                data: {
                    id: id
                },
                success: function( data ) {
                    $(e).closest(".product_preview").fadeOut(100, function() {
                        $(this).parent().remove();

                        if ($(".product_preview").length === 0) {
                            $("#favourites-products").remove();
                            $(".no-favourites").show();
                        }
                    });

                    Notifications.success(data);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    Notifications.fail(jqXHR.responseText);
                },
                complete: function(data) {
                    $(".ajax-load-overlay").hide();
                }
            });
        }
    };

    self.getProductsArray = function (data) {
        return [{"product": data}];
    };

    self.displayAlternatesModal = function () {
        $("#alternate-products-modal-" + self.slug).modal();
    };

    self.hasAlternatesForDisplay = function () {
        if (self.onlyDisplayAlternates === "1" && doesProductHaveAlternateCustomField()) {
            return true;
        }

        return false;
    };

    var doesProductHaveAlternateCustomField = function () {
        var hasField = false;
        _.forEach(self.customFields, function (field) {
            if (field.name === self.displayAlternateField) {
                hasField = true;
            }
        });

        return hasField;
    };

    var extractAlternatePartNums = function (data)
    {
        return _.map(data.alts, "pn");
    };

    self.getAlternates = function (data) {
        $.ajax({
            url: base_index_url + "alternate-parts",
            data: {
                "alternatePartNumbers": extractAlternatePartNums(data.alternateParts),
            },
            dataType: "json",
            type: "POST",
            success: function (data) {
                _.forEach(data, function (preview) {
                    var detailProduct = new window.catalog.ProductPreview(preview);
                    var element = document.getElementById("product-preview-modal-" + detailProduct.slug);

                    ko.cleanNode(element);
                    ko.applyBindings(detailProduct, element);
                });
            }
        });

    };

    self.checkIsGridView = function () {
        return true;
    };

    self.displayPreOrderPricing = function () {
        $(".pre-order-pricing-button").popover({
            container: "body",
            html: true,
            content: function() {
                popoverContent = $(this).parent().find(".pre-order-pricing").html();
                return popoverContent;
            }
        })
        .on('shown.bs.popover',function(e){
            $(".popover").css("min-width","600px");
        });
    };

    self.hasPreOrderPricing = function () {
        return self.preOrderPricing.length > 0;
    };

    self.showCustomerPartNumberModal = function (data) {
        self.showModal("#customer-part-number-modal-" + self.slug);
    };

    self.showModal = function (id) {
        $(id).modal();
    };

    self.hideModal = function (id) {
        $(id).modal("hide");
    };

    self.hasCustomerPartNumber = ko.computed(function () {
        return !_.isEmpty(self.customerPartNumber());
    });

    self.saveCustomerPartNumber = function () {
        var customerPartNumberError = $("#customer-part-number-error");

        customerPartNumberError.addClass("hide");

        if (!isAlphanumericDashUnderscore(self.newCustomerPartNumber())) {
            customerPartNumberError.removeClass("hide");
        } else {
            $.ajax({
                url: base_index_url + "customer-part-number",
                type: "POST",
                data: {
                    partNum: self.partNumber,
                    customerPartNumber: self.newCustomerPartNumber()
                },
                dataType: "json",
                success: function(response) {
                    self.updateCustomerPartNumber(self.newCustomerPartNumber());
                    self.hideModal("#customer-part-number-modal-" + self.slug);

                    Notifications.success(response.message);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    Notifications.fail(jqXHR.responseText);
                }
            });
        }
    };

    self.deleteCustomerPartNumber = function () {
        $.ajax({
            url: base_index_url + "customer-part-number/delete",
            type: "POST",
            data: {
                partNum: self.partNumber,
            },
            dataType: "json",
            success: function(response) {
                self.updateCustomerPartNumber("");
                self.hideModal("#customer-part-number-modal-" + self.slug);

                Notifications.success(response.message);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                Notifications.fail(jqXHR.responseText);
            }
        });
    };

    self.updateCustomerPartNumber = function (value) {
        self.customerPartNumber(value);
        self.newCustomerPartNumber("");
    };

    self.loadNotifyMeTemplates = function (vm, data, email) {
        if (email) {
            $.ajax({
                url: base_index_url + "notify-me",
                type: "POST",
                data: {
                    partNum: self.partNumber,
                    warehouse: self.warehouseId,
                    email: email
                },
                dataType: "json",
                success: function(response) {
                    self.isOnSaleNotification(_.includes(response,"OnSale"));
                    self.isInStockNotification(_.includes(response,"BackInStock"));
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    Notifications.fail(jqXHR.responseText);
                }
            });
        }

        self.showModal("#notify-me-template-modal-" + self.slug);
    };

    self.updateNotifications = function () {
        var email = $("#notify-email-" + self.slug).val();

        $.ajax({
            url: base_index_url + "notify-me/create",
            type: "POST",
            data: {
                partNum: self.partNumber,
                warehouse: self.warehouseId,
                email: email,
                conditions : {
                    OnSale : self.isOnSaleNotification,
                    BackInStock : self.isInStockNotification
                }
            },
            dataType: "json",
            success: function(response) {
                Notifications.success(response.message);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                Notifications.fail(jqXHR.responseText);
            }
        });

        self.hideModal("#notify-me-template-modal-" + self.slug);
    };

    self.showSelectedUomOnSaleEndDate = function (uom) {
        return uom == self.selectedUOM();
    };

    self.formatDate = function (date, format)
    {
        return new Date(date).toDateString();
    };

    self.hasProductAddons = function () {
        return !_.isEmpty(self.addons) ? true : false;
    };

    self.isItemPurchasable = function () {
        return parseInt(self.isPurchasable) === 1 ? true : false;
    };

    self.hasEquipmentRegistryDetails = function () {
        return !_.isEmpty(self.equipmentRegistryDetails);
    };

    self.equipmentRegistryId = function() {
        return self.hasEquipmentRegistryDetails() ? self.equipmentRegistryDetails.equipmentRegistryId : "";
    };

    self.showPartDiagramsCondensed = function () {
        return self.hasPartDiagrams && self.partDiagrams.length > 5;
    };

    self.showPartDiagram = function () {
        if (!_.isEmpty(self.chosenDiagram)) {
            window.location = self.chosenDiagram.url;
        }
    };

    (function () {
        _.forEach(self.statuses, function (status) {
            if (status.name === "on_sale") {
                self.onSaleStatuses.push(status);
            }
        });

        _.forEach(self.statuses, function (status) {
            if (status.name === "on_sale") {
                self.isOnSale = true;
            }
        });
    })();

    $("#search-container").on("mouseenter", ".product_list .product_preview, .product_list .product_preview_list", function() {
        $(this).find(".quick-view-trigger").fadeIn("fast");
    });

    $("#search-container").on("mouseleave", ".product_list .product_preview, .product_list .product_preview_list", function() {
        $(this).find(".quick-view-trigger").fadeOut("fast");
    });
};

window.checkout = window.checkout || {};

checkout.checkoutForm = null;
checkout.orderReviewForm = null;
checkout.arPaymentForm = null;
checkout.isOrderTotalZero = false;
checkout.paypalLoginComplete = false;
checkout.isGuestUser = true;
checkout.avalaraTaxEnabled = false;
checkout.currency = "";
checkout.rawTotal = 0;

function isOrderTotalGreaterThanZero()
{
    return !checkout.isOrderTotalZero;
}

function addressLineLength()
{
    return checkout.config.addressLineLength;
}

checkout.validationRules = {
    billing_fname: {
        required: true
    },
    billing_lname: {
        required: true
    },
    billing_line_1: {
        required: true,
        maxlength: addressLineLength
    },
    billing_line_2: {
        maxlength: addressLineLength
    },
    billing_line_3: {
        maxlength: addressLineLength
    },
    billing_line_4: {
        maxlength: addressLineLength
    },
    billing_country: {
        required: true
    },
    billing_country_division: {
        required: true
    },
    billing_city: {
        required: true
    },
    billing_postal_code: {
        required: {
            depends: function () {
                $(this).val($.trim($(this).val()));

                return true;
            }
        },
        postalCode: true
    },
    billing_phone: {
        required: true
    },
    billing_email: {
        required: {
            depends: function () {
                $(this).val($.trim($(this).val()));

                return true;
            }
        },
        email: true
    },
    shipping_name: {
        required: true
    },
    shipping_fname: {
        required: true
    },
    shipping_lname: {
        required: true
    },
    shipping_line_1: {
        required: true,
        maxlength: addressLineLength
    },
    shipping_line_2: {
        maxlength: addressLineLength
    },
    shipping_line_3: {
        maxlength: addressLineLength
    },
    shipping_line_4: {
        maxlength: addressLineLength
    },
    shipping_country: {
        required: true
    },
    shipping_country_division: {
        required: true
    },
    shipping_city: {
        required: true
    },
    shipping_phone: {
        required: true
    },
    shipping_postal_code: {
        required: true,
        postalCode: true
    },
    shipping_email: {
        required: true,
        email: true
    },
    // we set checkout.validationRules.ship_method.required in CheckoutConfig.tpl based off checkout setting
    ship_method: {
        required: true
    },
    payment_method: {
        required: { depends: isOrderTotalGreaterThanZero}
    },
    // we set checkout.validationRules.required_date.required in CheckoutConfig.tpl based off checkout setting
    required_date: {
        required: false
    },
    // we set checkout.validationRules.agree.required in CheckoutConfig.tpl based off checkout setting
    agree: {
        required: true
    },
};

function isOrderReview()
{
    return checkout.orderReviewForm.length > 0;
}

function isArPayment()
{
    return checkout.arPaymentForm.length > 0;
}

function setButtonDisableStatus(status) {
    $(".canDisable").prop("disabled", status);
}

function setPaymentToken(token)
{
    $("#paymentToken").val(token);
}

function getSelectedPaymentMethod()
{
    return isArPayment() ? $("#paymentMethod") : $("input[name='payment_method']").filter(":checked");
}

function isStripePayment()
{
    return getSelectedPaymentMethod().val() === "Stripe";
}

function isBamboraPayment()
{
    return getSelectedPaymentMethod().val() === "Bambora";
}

function isMonerisPayment()
{
    return getSelectedPaymentMethod().val() === "Moneris";
}

function isPaypalPayment()
{
    return getSelectedPaymentMethod().val() === "Paypal";
}

function isPaypalValid()
{
    if (isPaypalPayment() && !checkout.paypalLoginComplete) {
        setCheckoutFormError(checkout.config.logInToPaypal);

        return false;
    }

    return true;
}

function isReviewButtonVisible()
{
    return $("#review-button").length > 0;
}

function setCheckoutFormError(text)
{
    $("#checkout-form-error").html(text).removeClass("hide");
}

function clearCheckoutFormError()
{
    $("#checkout-form-error").html("").addClass("hide");
}

function triggerAddressChange()
{
    $(".addressChange").trigger("change");
}

$(document).ready(function() {
    checkout.checkoutForm = $("#checkout-form");
    checkout.orderReviewForm = $("#order-review-form");
    checkout.arPaymentForm = $("#arPaymentForm");

    var spinClass = "fa-spin";
    var loading_img = '<i class="fas fa-spinner ' + spinClass + ' loading_image"></i>';
    var tableShippingMethods = $("#shipping-methods-grid");
    var tableShippingMethodsNotAvailableMessage = '<div class="alert-info p-1 px-2 my-1">' + $(tableShippingMethods).find(".alert-info").text() + "</div>";
    var billingAddressValidationError = $("#billingAddressValidationError");
    var shippingAddressValidationError = $("#shippingAddressValidationError");
    var shipAddress = $("input[name='ship_address']");
    var shipCustomerAddress = $("select[name='ship_customer_address']");
    var shipItemsWhenAvailableSection = $("#ship-items-when-available");
    var couponMessage = $("#coupon-message");
    var productCouponSectionFollows = $("#product-coupon-section-follows");
    var shippingCouponSectionFollows = $("#shipping-coupon-section-follows");
    var orderTotalCouponSectionFollows = $("#order-total-coupon-section-follows");
    var readyToShipDateSectionFollows = $("#ready-to-ship-date-section-follows");
    var estimatedDeliveryDateSectionFollows = $("#estimated-delivery-date-section-follows");
    var couponCodeInput = $("#coupon_code");
    var giftCertificateInput = $("#gift-certificate-code");
    var giftCertificateAdd = $("#add-gift-certificate");
    var giftCertificateMessage = $("#gift-certificate-message");
    var giftCertificateSectionFollows = $("#gift-certificate-section-follows");
    var productQtys = $("input.product-qty");
    var productComments = $("textarea.product-comments");
    var removeItem = $("input.remove-item");
    var orderUpdateErrorsRow = $("#order-update-errors-row");
    var checkoutButton = $("#checkout-button");
    var paypalButtonRow = $("#paypal-button-row");
    var updateCartButton = $("#update-cart");
    var removeItemsButton = $("#remove-items");
    var dwellingType = $("#dwellingType");
    var isResidential = $("#isResidential");
    var totalWeightSection = $("#total-weight");
    var shipMethodName = "ship_method";
    var shipMethodInputs = $("input[name='" + shipMethodName + "']");
    var paymentMethodName = "payment_method";
    var paymentMethodInputs = $("input[name='" + paymentMethodName + "']"); // checkout
    var paymentMethodSelect = $("select[name='" + paymentMethodName + "']"); // ar payments
    var poField = $("#po_num");
    var purchasingHeaderReq = $("#purchasing-header").find("span.req");
    var pmInfo = $(".pminfo");
    var billingEmail = $("input[name='billing_email']");
    var stripePaymentElement = $("#stripe-payment");
    var bamboraPaymentElement = $("#bambora-payment");
    var monerisPaymentElement = $("#moneris-payment");
    var taxCalculatedOnReview = $(".tax-calculated-on-review");
    var taxExemptedProductRow = $(".tax-exempted-product");
    var taxExemptedProductDetailRow = $(".tax-exempted-product-detail");
    var taxExemptionMessage = $("#tax-exemption-message");
    var taxExemptionDetailMessage = $("#tax-exemption-detail-message");
    var orderTotalDiscountRow = $("#order-total-discount-row");

    if (!isMobile) {
        $(".checkout-sticky").sticky();

        document.onscroll = function() {
            document.activeElement.blur();
        };
    }

    if (paymentMethodInputs.length == 1) {
        paymentMethodInputs.prop("checked", true);
    }

    function isOnAccountPayment()
    {
       return getSelectedPaymentMethod().val() === "OnAccount";
    }

    function togglePORequirements() {
        if (poField.data("po_is_required") === 1) {
            poField.addClass("required");
            purchasingHeaderReq.removeClass("hide");

            if (!(poField.data("po_is_optional") === 1 && !isOnAccountPayment())) {
                return;
            }
        }

        poField.removeClass("required");
        purchasingHeaderReq.addClass("hide");
    }

    function togglePaymentInfo(id)
    {
        pmInfo.hide();
        $("." + id).show();
    }

    function isInlinePayment()
    {
        return getSelectedPaymentMethod().data("isInlinePayment");
    }

    function hideInlinePaymentForms()
    {
        stripePaymentElement.addClass("hide");
        bamboraPaymentElement.addClass("bambora-hidden");
        monerisPaymentElement.addClass("hide");
    }

    function populateMonerisAvsInfo()
    {
        var streetNum = $("#monerisStreetNumber"),
            streetName = $("#monerisStreetName"),
            postalCode = $("#monerisPostalCode");

        if (streetNum.val() == "" && streetName.val() == "" && postalCode.val() == "") {
            var billingLine1 = $("#billing-line-1").val();

            streetName.val(billingLine1.substring(billingLine1.indexOf(" ") + 1));
            streetNum.val(billingLine1.replace(streetName.val(), "").trim());
            postalCode.val($("#billing-postal-code").val());
        }
    }

    function setCheckoutButtonText(element)
    {
        hideInlinePaymentForms();

        if (checkout.checkoutForm.length) {
            togglePaymentInfo(element.attr("id"));
            togglePORequirements();


            var text = checkout.config.checkoutButtonText;
            if ($.inArray(element.val(), checkout.config.externalPaymentProviders) > -1 && !checkout.isOrderTotalZero && !isPaypalPayment()) {
                text = isInlinePayment() ? checkout.config.checkoutButtonTextPay : checkout.config.checkoutButtonTextHpp;
            }

            checkoutButton.children("span.button-text").text(text);
        }

        if (isStripePayment()) {
            stripePaymentElement.removeClass("hide");
        } else if (isBamboraPayment()) {
            bamboraPaymentElement.removeClass("bambora-hidden");
        } else if (isMonerisPayment()) {
            populateMonerisAvsInfo();
            monerisPaymentElement.removeClass("hide");
        } else if (isPaypalPayment() && !checkout.paypalLoginComplete) {
            paypalButtonRow.effect("shake", { direction: "up", times: 2, distance: 10});
        }
    }

    var selectedPaymentMethod = getSelectedPaymentMethod();
    if (selectedPaymentMethod.length) {
        setCheckoutButtonText(selectedPaymentMethod);
    }

    paymentMethodInputs.change(function() {
        setCheckoutButtonText($(this));
    });

    paymentMethodSelect.change(function() {
        setCheckoutButtonText($(this));
    });

    function setDwelingType(element) {
        if (dwellingType.length) {
            dwellingType.val(element.attr("data-shippingDwellingId"));
        }
    }

    shipAddress.change(function() {
        var self = $(this),
            type = self.val();

        setDwelingType(self);
        showHideShippingAddressOptions(type);
        showHideTaxCalculatedOnReview(type);

        if (type === "customer_address") {
            shipCustomerAddress.trigger("change");
        } else {
            populate_shipping_methods();
        }
    });

    function showHideShippingAddressOptions(type)
    {
        if (type === "same_as_billing") {
            $("#shipping_address").hide();
            $("#customerAddressSection, #updateShippingAddressSection").hide();
            shipCustomerAddress.val("");
        } else if (type === "different_address") {
            $("#shipping_address, #firstNameRow, #lastNameRow").show();
            $("#nameRow, #customerAddressSection, #updateShippingAddressSection").hide();
            shipCustomerAddress.val("");
        } else if (type === "customer_address") {
            if (!_.isEmpty($(shipCustomerAddress).val())) {
                shipCustomerAddress.change();
            }

            if (checkout.config.lockBillingAndShippingAddressesForCustomer) {
                $("#shipping_address").hide();
            } else {
                $("#shipping_address").show();
            }

            $("#nameRow, #customerAddressSection, #updateShippingAddressSection").show();
            $("#firstNameRow, #lastNameRow").hide();
        }
    }

    function showHideTaxCalculatedOnReview(type)
    {
        taxCalculatedOnReview.addClass("hide");

        if (checkout.avalaraTaxEnabled && (checkout.isGuestUser || type == "different_address")) {
            taxCalculatedOnReview.removeClass("hide");
        }
    }

    (function initShipping() {
        var type = $("input[name='ship_address']:checked").val();

        showHideShippingAddressOptions(type);
        showHideTaxCalculatedOnReview(type);
        populate_shipping_methods();
    })();

    shipCustomerAddress.change(function() {
        var self = $(this);

        if (self.val() !== "") {
            setDwelingType(self.find(":selected"));
            populate_shipping_methods();
        }
    });


    $("#wrapper").on("blur", ".shippingMethodTrigger", function() {
        populate_shipping_methods();
    });

    function populate_shipping_methods() {
        var addressType = $("input[name='ship_address']:checked").val();

        setShipToAddress(addressType);

        if (!isIncompleteShipToAddress()) {
            tableShippingMethods.find("div").remove();
            tableShippingMethods.after(loading_img);
            $("div#no-shipping-rates-available").remove();

            if (checkout.getShippingRates) {
                checkout.getShippingRates.abort();
            }

            checkout.getShippingRates = process(
                "checkout/shipping/rates",
                checkout.shipToAddress
            );

            checkout.getShippingRates.done(function(data, textStatus, jqXHR) {
                if (checkout.config.displayShippingMethodsInDropdown) {
                    $("#section_shipping").find("#shipping-methods-grid").append("<div><select name='" + shipMethodName + "' class='custom-select browser-default' id='ship-method'><option value=''>--Choose a Shipping Method--</option></select></div>");
                }

                $.each(data.rates, function(key, value) {
                    if (key !== "errors") {
                        var speed = (value.translated_speed !== null && value.translated_speed !== "") ? " (" + value.translated_speed + ")" : "";

                        if (value.name != "error") {
                            var selected = '';

                            if (checkout.config.previouslySelectedShipMethod == key) {
                                selected = checkout.config.displayShippingMethodsInDropdown ? ' SELECTED' : ' checked="checked" ';
                            }

                            var costForDisplay = (!_.isEmpty(value.costForDisplay)) ? ": " + value.costForDisplay : "";
                            var rateNameAndCost = value.translated_name + speed + costForDisplay;

                            if (checkout.config.displayShippingMethodsInDropdown) {
                                $("#section_shipping").find("#ship-method").append("<option value='" + key + "' id='ship_method_" + key + "'" + selected + " data-carrier-id='" + value.carrier_id + "'>" + rateNameAndCost + '</option>');
                            } else {
                                $("#section_shipping").find("#shipping-methods-grid").append('<div><input ' + selected + ' type="radio" name="' + shipMethodName + '" value="' + key + '" id="ship_method_' + key + '" data-carrier-id="' + value.carrier_id + '"/> <label for="ship_method_' + key + '">' + rateNameAndCost + '</label></div>');
                            }
                        }
                    }
                });

                var shippingMethodRates = $("input[name='ship_method']");
                if (shippingMethodRates.length === 1) {
                    $(shippingMethodRates).prop("checked", true);
                }

                if (shippingMethodRates.is(":checked")) {
                    shippingMethodRates.filter(":checked").trigger("change");
                } else if ($("select[name='" + shipMethodName + "']").val() !== "") {
                    $("select[name='" + shipMethodName + "']").trigger("change");
                }

                updateTotals(data.totals);
            }).always(function (data, textStatus, jqXHR) {
                clearCouponMessage();
                tableShippingMethods.next(".loading_image").remove();
                displayShippingRateErrors(data.rates, tableShippingMethods);

                if (jqXHR.readyState === 4 && textStatus !== "abort") {
                    processValidationMessages(data.validation);
                }
            });
        }
    }

    function setShipToAddress(addressType) {
        if (addressType === "same_as_billing") {
            populateShipToAddress("billing");
            checkout.shipToAddress.same_as_billing = 1;
        } else {
            populateShipToAddress("shipping");

            if (shipCustomerAddress.is(":visible")) {
                checkout.shipToAddress.address_id = shipCustomerAddress.val();
            }
        }

        checkout.shipToAddress.method = addressType;

        if (dwellingType.length && dwellingType.val() !== "") {
            checkout.shipToAddress.dwellingType = dwellingType.val();
            checkout.shipToAddress.isResidential = isResidential.val();
        }

        if (isIncompleteShipToAddress()) {
            $(tableShippingMethods).html(tableShippingMethodsNotAvailableMessage);
        }
    }

    function populateShipToAddress(type)
    {
        var name = $("input[name='" + type + "_name']").val();

        if (type === "billing") {
            name = $("input[name='" + type + "_fname']").val() + " " + $("input[name='" + type + "_lname']").val();
        }

        checkout.shipToAddress = {
            "shipping_company": $("input[name='" + type + "_company']").val(),
            "shipping_name": name,
            "shipping_fname": $("input[name='" + type + "_fname']").val(),
            "shipping_lname": $("input[name='" + type + "_lname']").val(),
            "shipping_line_1": $("input[name='" + type + "_line_1']").val(),
            "shipping_line_2": $("input[name='" + type + "_line_2']").val(),
            "shipping_country": $("select[name='" + type + "_country']").val(),
            "shipping_country_division": $("select[name='" + type + "_country_division']").val(),
            "shipping_city": $("input[name='" + type + "_city']").val(),
            "shipping_postal_code": $("input[name='" + type + "_postal_code']").val(),
            "shipping_phone": $("input[name='" + type + "_phone']").val(),
            "shipping_ext": $("input[name='" + type + "_ext']").val(),
            "shipping_fax": $("input[name='" + type + "_fax']").val(),
            "shipping_email": $("input[name='" + type + "_email']").val(),
            "same_as_billing": 0,
            "address_id": "",
            "dwellingType": null,
            "isResidential": 0,
            "bill_customer_address_num": $("#billingAddressSelector").length ? $("#billingAddressSelector").val() : ""
        };
    }

    function isIncompleteShipToAddress() {
        return (_.isEmpty(checkout.shipToAddress.shipping_name) && _.isEmpty(checkout.shipToAddress.shipping_fname) && _.isEmpty(checkout.shipToAddress.shipping_lname)) ||
            _.isEmpty(checkout.shipToAddress.shipping_line_1) ||
            _.isEmpty(checkout.shipToAddress.shipping_country) ||
            _.isEmpty(checkout.shipToAddress.shipping_country_division) ||
            _.isEmpty(checkout.shipToAddress.shipping_city) ||
            _.isEmpty(checkout.shipToAddress.shipping_postal_code);
    }

    function displayShippingRateErrors(rates, element) {
        var errors = _.has(rates, "errors") ? rates.errors : [];
        var hasRateErrors = !_.isEmpty(errors);

        if (_.has(rates, "offlineShipping")) {
            element.after('<div id="no-shipping-rates-available" class="alert-danger p-1 px-2 my-1">' + checkout.config.noShippingRatesAvailable + '</div>');
        }

        if (hasRateErrors) {
            var rateErrorStart = '<div id="no-shipping-rates-available" class="alert-danger p-1 px-2 my-1"><ul>';
            var rateErrorEnd = "</ul></div>";
            var individualRateErrors = "";

            _.forEach(errors, function(error) {
                individualRateErrors += "<li>" + error + "</li>";
            });

            element.after(rateErrorStart + individualRateErrors + rateErrorEnd);
        }
    }

    function processValidationMessages(messages) {
        var addressType = $("input[name='ship_address']:checked").val();

        $.each(messages, function(key, value) {
            if (key === "address") {
                billingAddressValidationError.html("").addClass("hide");
                shippingAddressValidationError.html("").addClass("hide");

                if (!value.status) {
                    if (addressType === "same_as_billing") {
                        billingAddressValidationError.html(value.message).removeClass("hide");
                    } else {
                        shippingAddressValidationError.html(value.message).removeClass("hide");
                    }
                }
            }
        });
    }

    function setShippingMethodOnOrder(carrier) {
        var setShippingMethod = process(
            "checkout/shipping/rate/set",
            {
                "shipping_carrier": carrier,
                "required_date": $("input.required_date").val()
            }
        );

        setShippingMethod.always(function (result) {
            clearCouponMessage();
            updateTotals(result.totals);
        });
    }

    $(".required_date.datepicker").pickadate({
        onSet: function(dateText) {
            var selectedDate = moment($("#required_date").val()).format("YYYY-MM-DD");

            var requiredDate = process(
                "checkout/required-date",
                {
                    "required_date": selectedDate
                }
            );

            requiredDate.always(function (result) {
                updateTotals(result.totals);
            });
        }
    });

    $("#wrapper").on("change", "input[name='" + shipMethodName + "']", function() {
        setShippingMethodOnOrder($(this).val());
    });

    $("#wrapper").on("change", "select[name='" + shipMethodName + "']", function() {
        setShippingMethodOnOrder($(this).val());
    });

    $("input[name='billing_postal_code']").bind("keydown", alphanumeric);
    $("input[name='billing_phone']").bind("keydown", only_numbers);
    $("input[name='billing_fax']").bind("keydown", only_numbers);
    $("input[name='shipping_postal_code']").bind("keydown", alphanumeric);
    $("input[name='shipping_phone']").bind("keydown", only_numbers);
    $("input[name='shipping_fax']").bind("keydown", only_numbers);

    function clearCouponMessage() {
        couponMessage.html("").removeClass("text-success text-danger");
    }

    couponCodeInput.on("focus", function () {
        clearCouponMessage();
    });

    $("#apply-coupon").click(function () {
        var couponCodeValue = couponCodeInput.val();

        clearCouponMessage();

        if (!couponCodeValue) {
            couponCodeInput.focus();
        } else {
            $("#apply-coupon").children(":first").addClass(spinClass);

            var applyCoupon = process(
                "coupon/add",
                {
                    "couponCode": couponCodeValue
                }
            );

            applyCoupon.done(function (results) {
                couponCodeInput.val("");
                couponMessage.html(results.message).addClass("text-success");
                updateTotals(results.totals);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                setButtonDisableStatus(false);
                couponMessage.html(jqXHR.responseText).addClass("text-danger");
            }).always(function () {
                $("#apply-coupon").children(":first").removeClass(spinClass);
            });
        }
    });

    taxExemptedProductRow.change(function() {
        if(this.checked) {
            $("#" + this.id + "-modal").modal("show");
            var applyTaxExemption = process(
                "tax-exemption/add",
                {
                    "exemptedProductCustomField": this.name
                }
            );

            applyTaxExemption.done(function (results) {
                taxExemptionMessage.html(results.message).addClass("text-success");
                updateTotals(results.totals);
                setButtonDisableStatus(false);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                taxExemptionMessage.html(jqXHR.responseText).addClass("text-danger");
            }).always(function() {
                taxExemptedProductDetailRow.trigger("change");
            });
        } else {
            var removeTaxExemption = process(
                "tax-exemption/remove",
                {
                    "exemptedProductCustomField": this.name
                }
            );

            removeTaxExemption.done(function (results) {
                taxExemptionMessage.html(results.message).addClass("text-success");
                updateTotals(results.totals);
                setButtonDisableStatus(false);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                taxExemptionMessage.html(jqXHR.responseText).addClass("text-danger");
            }).always(function() {
                taxExemptionDetailMessage.html(" ").addClass("text-success");
            });
        }
    });

    taxExemptedProductDetailRow.change(function() {
        var exemptedProductField = this.name.substring(0, this.name.length - 8);
        var additionalDetail = this.value;

        if (additionalDetail && additionalDetail != "") {
            var updateTaxExemption = process(
                "tax-exemption/update",
                {
                    "exemptedProductCustomField": exemptedProductField,
                    "additionalDetail": additionalDetail
                }
            );

            updateTaxExemption.done(function (results) {
                taxExemptionDetailMessage.html(additionalDetail + " value saved successfully").addClass("text-success");
                setButtonDisableStatus(false);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                taxExemptionDetailMessage.html("Value not saved").addClass("text-danger");
            });
        }
    });

    function process(url, data) {
        setButtonDisableStatus(true);

        return $.ajax({
            url: base_index_url + url,
            type: "POST",
            data: data
        });
    }

    $("#wrapper").on("click", ".remove-coupon", function() {
        var couponId = $(this).data("coupon-id");

        if (confirm(checkout.config.removeCouponQuestion)) {
            var removeCoupon = process(
                "coupon/remove",
                {
                    "couponId": couponId
                }
            );

            removeCoupon.done(function(results) {
                $("#coupon-" + couponId).remove();
                updateTotals(results.totals);
            }).fail(function(jqXHR, textStatus, errorThrown) {
                alert(jqXHR.responseText);
            }).always(function () {
                setButtonDisableStatus(false);
                clearCouponMessage();
            });
        }
    });

    function clearGiftCertificateMessage() {
        giftCertificateMessage.html("").removeClass("text-success text-danger");
    }

    giftCertificateInput.on("focus", function () {
        clearGiftCertificateMessage();
    });

    $("#add-gift-certificate").click(function() {
        var code = giftCertificateInput.val();

        clearGiftCertificateMessage();

        if (!code) {
            giftCertificateInput.focus();
        } else {
            $("#add-gift-certificate").children(":first").addClass(spinClass);

            var applyGiftCertificate = process(
                "gift-certificate/add",
                {
                    "code": code
                }
            );

            applyGiftCertificate.done(function(results) {
                giftCertificateInput.val("");
                giftCertificateMessage.html(results.message).addClass("text-success");
                updateTotals(results.totals);
            }).fail(function(jqXHR, textStatus, errorThrown) {
                setButtonDisableStatus(false);
                giftCertificateMessage.html(jqXHR.responseText).addClass("text-danger");
            }).always(function () {
                $("#add-gift-certificate").children(":first").removeClass(spinClass);
            });
        }
    });

    $("#wrapper").on("click", ".remove-gift-certificate", function() {
        var giftCertificateId = $(this).data("gift-certificate-id");

        if (confirm(checkout.config.removeGiftCertificateQuestion)) {
            var removeGiftCertificate = process(
                "gift-certificate/remove",
                {
                    "giftCertificateId": giftCertificateId
                }
            );

            removeGiftCertificate.done(function(results) {
                $("#gift-certificate-" + giftCertificateId).remove();
                updateTotals(results.totals);
                setButtonDisableStatus(false);
                clearGiftCertificateMessage();
            });
        }
    });

    removeItemsButton.click(function(e) {
        if (!removeItem.is(":checked")) {
            e.preventDefault();
        }
    });

    updateCartButton.click(function(e) {
        e.preventDefault();
        clearOrderUpdateErrors();

        var updateData = [];
        var errors = [];

        productQtys.each(function() {
            var item = $(this);

            var partNum = item.data("part-num");
            var cartItemId = item.data("cart-item-id");
            var productKey = item.data("product-key");
            var comment = $("#comment-" + productKey);

            var data = {
                partNum: partNum,
                cartItemId: cartItemId,
                qty: item.val(),
                comment: comment.length ? comment.val() : ""
            };

            updateData.push(data);
        });

        var updateCart = process(
            "checkout/update-cart",
            {
                "updateData": updateData
            }
        );

        updateCart.done(function(results) {
            if (!_.isEmpty(results.errors)) {
                var errors = "";

                _.each(results.errors, function(error) {
                    errors += createErrorDiv(error);
                });

                setOrderUpdateErrorsRow(errors);
            } else {
                Notifications.success(checkout.config.orderUpdateSuccess);
            }
        }).always(function (results) {
            populate_shipping_methods();
            updateTotals(results.totals);
        });
    });

    function clearOrderUpdateErrors() {
        orderUpdateErrorsRow.addClass("hide");
        orderUpdateErrorsRow.find("div").remove();
    }

    function createErrorDiv(error) {
        return '<div class="bs bs-callout bs-callout-danger order-update-error">' + error + '</div>';
    }

    function setOrderUpdateErrorsRow(errors) {
        orderUpdateErrorsRow.append('<div>' + errors + '<div>');
        orderUpdateErrorsRow.removeClass("hide");
    }

    $("#wrapper").on("click", "input.order-additional-cost", function() {
        var $this = $(this);

        var applyAdditionalCost = process(
            $this.is(":checked") ? "additional-cost/add" : "additional-cost/remove",
            {
                "orderId": $this.data("orderId"),
                "orderAdditionalCostsSettingId": $this.data("orderAdditionalCostsSettingId")
            }
        );

        applyAdditionalCost.always(function(results) {
            updateTotals(results.totals);
        });
    });

    var updateTotals = function(result) {
        checkout.isOrderTotalZero = false;
        checkout.currency = result.currency;
        checkout.rawTotal = result.rawTotal;

        $(".tax_lineitem, .coupon-section, .gift-certificate-section, .selectable-additional-costs, .additional-costs-section, .ready-to-ship-date, .estimated-delivery-date").remove();

        updateProducts(result.products);
        updateSubTotal(result.subtotal);
        updateTotal(result.total);
        updatePromoDiscount(result.promoDiscount);
        updateCustomerDiscount(result.customerDiscount);
        updateShippingTotal(result.shipping);
        updateHandling(result);
        updateTaxes(result.taxes);
        updateAvailableAdditionalCosts(result.availableAdditionalCosts);
        updateAdditionalCosts(result.additional_costs);
        showAppliedCoupons(result.coupons.items);
        updateTotalWeight(result.totalWeight);
        updateReadyToShipDate(result.readyToShipDate);
        updateEstimatedDeliveryDate(result.estimatedDeliveryDate);
        updateOrderTotalDiscountMessage(result.orderTotalDiscountMessage);

        if (result.giftCertificates) {
            showAppliedGiftCertificates(result.giftCertificates.items);
        }

        if (result.isOrderTotalZero) {
            checkout.isOrderTotalZero = true;
            checkoutButton.children("span.button-text").text(checkout.config.checkoutButtonText);
            checkout.checkoutForm.valid();
        }

        shipItemsWhenAvailableSection.addClass("hide");
        if (result.showShipItemsWhenAvailableOptions) {
            shipItemsWhenAvailableSection.removeClass("hide");
        }

        setButtonDisableStatus(false);
    };

    window.Checkout = {
        Api: {
            updateTotals: updateTotals
        }
    };

    function updateProducts(products) {
        $.each(products, function(idx, product) {
            updateProduct(product);
            updateProductAddons(product.selectedAddons);
            updateAvailablePromotions(product);
            updateProductBackorderMessage(product);
        });
    }

    function updateProductAddons(addons) {
        $.each(addons, function(idx, product) {
            updateProduct(product);
        });
    }

    function updateProduct(product) {
        $("#qty-" + product.key).val(product.quantity + product.backorderQty);
        $("#addon-qty-" + product.key).html(product.quantity + product.backorderQty);
        $("#price-" + product.key).html(product.price);
        $("#addon-price-" + product.key).html(product.price);
        $("#total-" + product.key).html(product.total);
        $("#comment-" + product.key).val(product.comment);
    }

    function updateAvailablePromotions(product) {
        if (!_.isEmpty(product.availablePromotions)) {
            _.forEach(product.availablePromotions, function(promotion, key) {
                if (promotion.length > 0) {
                    _.forEach(promotion, function(promo) {
                        if ($("#promo-" + product.key + "-" + key).length === 0) {
                            $(".border-bottom-separator-row").before(buildPromoRow(product.key, promo, product));
                        } else {
                            $("#promo-" + product.key + "-" + key).html(promo.name + " - " + promo.discountDisplay);
                        }
                    });
                } else {
                    $("#promo-" + product.key).remove();
                }
            });
        } else if ($("#promo-" + product.key).length > 0) {
            $("#promo-" + product.key).remove();
        }
    }

    function updateProductBackorderMessage(product) {
        var backorderRow = $("#backorder-message-row-" + product.key);
        var ignoreBackorderProducts = $("#ignore-backorder-products-" + product.key);
        var qtyShipped = $("#qty-shipped-" + product.key);
        var qtyBackordered = $("#qty-backordered-" + product.key);
        var backorderMessage = $("#backorder-message-" + product.key);

        qtyShipped.html(product.quantity);
        qtyBackordered.html(product.backorderQty);

        if (product.stock.isBackordered) {
            if (product.backorderQty > 0 && checkout.config.ignoreBackorderProductsOnOrders) {
                ignoreBackorderProducts.removeClass("hide");
                qtyShipped.removeClass("hide");
                qtyBackordered.removeClass("hide");
                backorderMessage.html("").addClass("hide");
            } else {
                ignoreBackorderProducts.addClass("hide");
                qtyShipped.addClass("hide");
                qtyBackordered.addClass("hide");
                backorderMessage.html(product.stock.display.backorderMessage).removeClass("hide");
            }

            backorderRow.removeClass("hide");
        } else if (backorderRow.length) {
            backorderRow.addClass("hide");
        }
    }

    function buildPromoRow(key, promo, product) {
        var temp = '<div id="promo-' + key + '" class="bs-callout bs-callout-success">';
        temp += '<span id="promo-' + key + '-' + product.part_number + '">' + promo.name + ' - ' + promo.discountDisplay + '</span>';
        temp += '</div>';

        return temp;
    }

    function updateSubTotal(subtotal) {
        $("#subtotalValue > span.subtotal-value").html(subtotal);
    }

    function updateTotal(total) {
        $("#totalValue > span.total-value").html(total);
    }

    function updatePromoDiscount(promoDiscount) {
        var promoDiscountTotal = $(".promo_discount_total");
        var promoDiscountTotalTR = promoDiscountTotal.parent("div");

        promoDiscountTotalTR.addClass("hide");
        promoDiscountTotal.html("-" + promoDiscount.value);

        if (promoDiscount.show) {
            promoDiscountTotalTR.removeClass("hide");
        }
    }

    function updateCustomerDiscount(customerDiscount) {
        var customerDiscountTotal = $(".customer_discount_total");
        var customerDiscountTotalTR = customerDiscountTotal.parent("div");

        customerDiscountTotalTR.addClass("hide");
        customerDiscountTotal.html("-" + customerDiscount.value);

        if (customerDiscount.show) {
            customerDiscountTotalTR.removeClass("hide");
        }
    }

    function updateShippingTotal(shipping) {
        $(".ship_total").html(shipping);
    }

    function updateHandling(data) {
        var handlingFeeRow = $('#handling-fee-row');

        if (data.showHandlingFee) {
            handlingFeeRow.show();
        } else {
            handlingFeeRow.hide();
        }

        $(".handling_fee").html(data.handlingDisplay);
    }

    function updateTaxes(taxes) {
        if (taxes.data) {
            $.each(taxes.data, function(key, val) {
                if (!val.exempt) {
                    var taxRow = '<div class="row font-weight-bold tax_lineitem"><div class="col text-uppercase">' + val.description.short + '</div><div class="text-right tax_total col updatable">' + val.amount + '</div></div>';

                    var taxLineItem = $(".tax_lineitem");

                    if (taxLineItem.length) {
                        taxLineItem.last().after(taxRow);
                    } else {
                        $("#tax-section-follows").after(taxRow);
                    }
                }
            });
        }
    }

    function updateAvailableAdditionalCosts(additionalCosts) {
        if (!_.isEmpty(additionalCosts)) {
            var start = '<div class="selectable-additional-costs p-2 mb-2"><h7>' + checkout.config.availableExtras + '</h7><hr>';
            var end = '</div>';
            var availableAdditionalCostsSection = "";

            _.each(additionalCosts, function(cost) {
                var checked = cost.isAdditionalCostApplied ? 'checked="checked"' : "";

                availableAdditionalCostsSection += '<div class="row text-right"><div class="col text-right"><div class="form-check">';
                availableAdditionalCostsSection += '<input type="checkbox" id="additional-cost-' + cost.id + '" class="filled-in form-check-input order-additional-cost" data-order-id="' + cost.orderId + '" data-order-additional-costs-setting-id="' + cost.id + '" ' + checked + '>';
                availableAdditionalCostsSection += '<label for="additional-cost-' + cost.id + '" class="form-check-label">' + cost.displayName + ' ' + cost.combinedTotal + '</label>';
            });

            $("#selectable-additional-costs-section-follows").after(start + availableAdditionalCostsSection + end);
        }
    }

    function updateReadyToShipDate(readyToShipDate) {
        if (readyToShipDateSectionFollows.length && !_.isEmpty(readyToShipDate)) {
            readyToShipDateSectionFollows.after(buildShippingDateRow("ready-to-ship-date", checkout.config.readyToShip, readyToShipDate));
        }
    }

    function updateEstimatedDeliveryDate(estimatedDeliveryDate) {
        if (estimatedDeliveryDateSectionFollows.length && !_.isEmpty(estimatedDeliveryDate)) {
            estimatedDeliveryDateSectionFollows.after(buildShippingDateRow("estimated-delivery-date", checkout.config.estimatedDelivery, estimatedDeliveryDate));
        }
    }

    function buildShippingDateRow(section, description, date) {
        var start = '<div class="' + section + ' text-right"><div>';
        var end = '</div></div>';
        var details = "";

        details += '<div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">' + description + '</h3></div>';
        details += '<div class="panel-body">' + date + '</div></div>';

        return start + details + end;
    }

    function updateOrderTotalDiscountMessage(message)
    {
        orderTotalDiscountRow.hide();

        if (!_.isEmpty(message)) {
            orderTotalDiscountRow.html(message).show();
        }
    }

    function updateAdditionalCosts(additionalCosts) {
        var additionalCostsSection = "";

        $.each(additionalCosts, function(key, cost) {
            var section = "";

            if (cost.combinedTotal.displayName !== undefined) {
                var description = cost.combinedTotal.description;
                var label = cost.combinedTotal.displayName;
                var price = cost.combinedTotal.cost;

                section = buildAdditionalCostRow(description, label, price);
            } else {
                $.each(cost.rules, function(key, rule) {
                    var description = rule.description;
                    var label = rule.displayName;
                    var price = rule.cost;

                    section += buildAdditionalCostRow(description, label, price);
                });
            }

            additionalCostsSection += section;
        });

        $("#additional-costs-section-follows").after(additionalCostsSection);
    }

    function updateTotalWeight(totalWeight) {
        if (totalWeightSection) {
            $("#total-weight-value").html(totalWeight);
        }
    }

    function buildAdditionalCostRow(description, label, price) {
        var additionalCostRow = '<div class="row additional-costs-section">';
        additionalCostRow += '<div class="col"><span class="text-uppercase">' + label + '</span>&nbsp;';
        additionalCostRow += '</div><div class="col text-right updatable">' + price + '</div></div>';

        return additionalCostRow;
    }

    function showAppliedCoupons(appliedCoupons) {
        var productCouponDisplayRows = "";
        var shippingCouponDisplayRows = "";
        var orderTotalCouponDisplayRows = "";

        $("#section_review").find(".coupon-section").remove();

        $.each(appliedCoupons, function(idx, coupon) {
            var row = buildCouponRow(coupon);

            if (coupon.type.name === "Order" || coupon.type.name === "Order Total") {
                orderTotalCouponDisplayRows += row;
            } else if (coupon.type.name === "Shipping") {
                shippingCouponDisplayRows += row;
            } else {
                productCouponDisplayRows += row;
            }
        });

        productCouponSectionFollows.after(productCouponDisplayRows);
        shippingCouponSectionFollows.after(shippingCouponDisplayRows);
        orderTotalCouponSectionFollows.after(orderTotalCouponDisplayRows);
    }

    function buildCouponRow(coupon) {
        var row = '<div id="coupon-' + coupon.id + '" class="row text-danger coupon-section"><div class="col">';

        row += '<span class="text-uppercase">' + coupon.name + '</span>&nbsp;';

        var iconClass = "fas fa-trash-alt remove-coupon";
        var title = checkout.config.removeCoupon;

        if (coupon.promotion) {
            iconClass = "fas fa-info-circle text-info";
            title = checkout.config.promotionCoupon;
        }

        row += '<i class="' + iconClass + ' zs-tooltip" style="cursor: pointer;" data-coupon-id="' + coupon.id + '" title="' + title + '"></i>';

        return row += '</div><div class="col text-right updatable">-' + coupon.discountDisplay + '</div></div>';
    }

    function showAppliedGiftCertificates(giftCertificates) {
        var giftCertificateDisplayRows = "";

        $("#section_review").find(".gift-certificate-section").remove();

        $.each(giftCertificates, function(idx, giftCertificate) {
            giftCertificateDisplayRows += '<div id="gift-certificate-' + giftCertificate.id + '" class="row text-danger gift-certificate-section">';
            giftCertificateDisplayRows += '<div class="col"><span class="text-uppercase">' + giftCertificate.name + '</span>&nbsp;';
            giftCertificateDisplayRows += '<i class="fas fa-trash-alt remove-gift-certificate zs-tooltip" style="cursor: pointer;" data-gift-certificate-id="' + giftCertificate.id + '" title="' + checkout.config.removeGiftCertificate + '"></i>';
            giftCertificateDisplayRows += '</div><div class="col text-right updatable">-' + giftCertificate.discountDisplay + '</div></div>';
        });

        giftCertificateSectionFollows.after(giftCertificateDisplayRows);
    }

    function show_address_fields(type) {
        if (type == "billing" || type == "shipping") {
            if ($("input[name='" + type + "_line_1']").val() && $("input[name='" + type + "_line_2']").val()) {
                $("input[name='" + type + "_line_3']").show();
                $("input[name='" + type + "_line_3']").prev("div").show();
                if ($("input[name='" + type + "_line_3']").val()) {
                    $("input[name='" + type + "_line_4']").show();
                    $("input[name='" + type + "_line_4']").prev("div").show();
                }
            }
        }
    }

    $("input[name='billing_line_1']").keydown(function() {
        show_address_fields("billing");
    });
    $("input[name='billing_line_2']").keydown(function() {
        show_address_fields("billing");
    });
    $("input[name='billing_line_3']").keydown(function() {
        show_address_fields("billing");
    });
    show_address_fields("billing");
    $("input[name='shipping_line_1']").keydown(function() {
        show_address_fields("shipping");
    });
    $("input[name='shipping_line_2']").keydown(function() {
        show_address_fields("shipping");
    });
    $("input[name='shipping_line_3']").keydown(function() {
        show_address_fields("shipping");
    });
    show_address_fields("shipping");

    function formatMoneyValue(value) {
        if (typeof(value) == 'string')
            value = value.replace(',', '');
        return parseFloat(value).toFixed(2);
    }

    checkout.checkoutForm.validate({
        errorClass : "badge badge-danger",
        errorElement :  "span",
        rules : checkout.validationRules,
        highlight: function(element, errorClass) {
            errorClass = "";
        },
        errorPlacement: function(label, element) {
            var id = element.attr("id");
            var name = element.attr("name");

            if (id && id.includes("-agree")) {
                element.next().append("<br/>", label);
            } else if (name == "ship_method") {
                $("#shipping-error").html(label);
            } else if (name == paymentMethodName) {
                $("#payment-error").html(label);
            } else {
                label.insertAfter(element);
            }
        },
        invalidHandler: function(element, validator) {
            var errorCount = validator.numberOfInvalids();
            var message = (errorCount == 1) ? checkout.config.singleErrorExist : checkout.config.multipleErrorsExist;

            setCheckoutFormError(errorCount + " " + message);
        }
    });

    $.validator.addMethod("postalCode", function(value, element) {
        var country = $(element).attr("id") === "billing-postal-code" ? $("#billing_country").val() : $("#shipping_country").val();

        if (country === "CAN") {
            return value.match(/^[a-zA-Z][0-9][a-zA-Z](-| )?[0-9][a-zA-Z][0-9]$/);
        } else if (country === "USA") {
            return value.match(/^\d{5}(?:[-\s]\d{4})?$/);
        } else {
            return true;
        }

   }, function (key, element) {
        var message = "";
        var country = $(element).attr("id") === "billing-postal-code" ? $("#billing_country").val() : $("#shipping_country").val();

        if (country === "CAN") {
            message = checkout.config.postalCodeInvalid;
        } else if (country === "USA") {
            message = checkout.config.zipCodeInvalid;
        }

        return message;
   });

    function resetRemoveItems() {
        removeItem.prop("checked", false);
    }

    function showProcessingOrderMessage()
    {
        Notifications.persist(checkout.config.processingOrder);

        if (!_.isEmpty(checkout.reCaptchaV3SiteKey)) {
            document.getElementById("checkout-form").submit();
        }
    }

    function processCheckout(e) {
        if (!isOrderReview()) {
            resetRemoveItems();
            clearCheckoutFormError();

            if (checkout.checkoutForm.length && checkout.checkoutForm.valid() && !checkout.isOrderTotalZero) {
                if (isStripePayment()) {
                    stripeHandler(e);
                } else if (isBamboraPayment()) {
                    bamboraHandler.onClick(e);
                } else if (isMonerisPayment()) {
                    monerisHandler(e);
                } else if (isPaypalPayment()) {
                    if (!isPaypalValid()) {
                        e.preventDefault();
                    } else {
                        showProcessingOrderMessage();
                    }
                } else {
                    showProcessingOrderMessage();
                }
            } else if (checkout.isOrderTotalZero) {
                showProcessingOrderMessage();
            }
        }
    }

    $("body").on("click", "#checkout-button, #review-button", function(e) {
        if (!isOrderReview()) {
            if (_.isEmpty(checkout.reCaptchaV3SiteKey)) {
                processCheckout(e);
            } else {
                e.preventDefault();
                grecaptcha.ready(function() {
                  grecaptcha.execute(checkout.reCaptchaV3SiteKey, {action: 'submit'}).then(function(token) {
                      $("#g-recaptcha").val(token);
                      processCheckout(e);
                  });
                });
            }
        }
    });

    triggerAddressChange();
});

window.productComments = window.productComments || {};

var SearchViewModel = function (payload, productCarouselSettings) {
    var self = this;

    self.productCarouselSettings = productCarouselSettings;
    self.totalHits = ko.observable(0);
    self.items = ko.observableArray([]);
    self.relatedProducts = ko.observableArray([]);
    self.currentGroup = "";
    self.currentGrouping = ko.observable(undefined);
    self.isGridView = ko.observable();

    self.hasResults = ko.computed(function () {
        return self.items().length > 0;
    });

    self.hasRelatedProducts = ko.computed(function () {
        return self.relatedProducts().length > 0;
    });

    self.hasResultsOrRelatedProducts = function () {
        return self.hasResults() || self.hasRelatedProducts();
    };

    self.isValidGroupingOption = function(field) {
        if (field === "") {
            return true;
        }

        if (payload.settings.groupingFieldSettings.length > 0) {
            existingDefault = ko.utils.arrayFirst(payload.settings.groupingFieldSettings, function(item) {
                return item.field == field;
            });

            return existingDefault ? true : false;
        }

        return true;
    };

    self.areAddonsPresent = function () {
        var addonsPresent = false;

        if (!_.isEmpty(payload.results)) {
            for (var i = 0; i < payload.results.items.length; i++) {
                if (payload.results.items[i].addons.length > 0) {
                    addonsPresent = true;
                }
            }
        }

        return addonsPresent;
    };

    self.setupDefaultGroupingOption = function() {
        self.defaultGrouping = payload.settings.defaultGrouping;
        if(!self.isValidGroupingOption(self.defaultGrouping)) {
            self.defaultGrouping = payload.settings.groupingFieldSettings[0].field;
        }
    };

    self.setupCurrentGrouping = function() {
        var currentGroupBy = window.SearchApi.currentSearch.groupBy;
        self.currentGrouping = ko.observable(currentGroupBy === "" ? undefined : currentGroupBy);

        if(self.currentGrouping() !== undefined && !self.isValidGroupingOption(self.currentGrouping())) {
            self.currentGrouping(self.defaultGrouping);
        }
    };

    self.isGroupingActive = function() {
        return payload.settings.config.displayGroupByHeaders === true && self.currentGrouping();
    };

    self.hasGroupingChanged = function(searchResult) {
        groupingValue = searchResult.groupingValue(self.currentGrouping());
        if(self.currentGroup != groupingValue) {
            self.currentGroup = groupingValue;
            return true;
        }

        return false;
    };

    self.loadTemplate = function(result) {
        return "product-preview-template";
    };

    self.buildResults = function(data) {
        self.currentGrouping(window.SearchApi.currentSearch.groupBy);

        var items = [];
        var totalHits = 0;
        var relatedProducts = [];

        if (!window.Search.performSearchRedirect(data)) {
            if(data && data.items) {
                totalHits = data.totalHits;
                relatedProducts = data.relatedProducts;

                ko.utils.arrayForEach(data.items, function(item) {
                    items.push(new ProductSearchResult(item));

                    window.productComments[item.slug] = item.cartComments;
                });
            }

            self.items(items);
            self.totalHits(totalHits);
            self.buildRelatedProducts(relatedProducts);
            self.refreshPopover();
        } else {
            self.items([]);
            self.relatedProducts([]);
        }
    };

    self.productGridRows = function(columnCount) {
        if (self.isGroupingActive()) {
            return self.getGroupedSearchResults(columnCount);
        }

        return _.chunk(self.items(), columnCount);
    };

    self.getGroupedSearchResults = function(columnCount) {
        resultItems = [];
        resultGroup=[];
        _.each(self.items(), function(item, key) {
            if ((self.hasGroupingChanged(item) === false ) || (key === 0 )) {
                resultGroup.push(item);
            } else {
                _.each(_.chunk(resultGroup, columnCount), function(group) {
                    resultItems.push(group);
                });
                resultGroup = [];
                resultGroup.push(item);
            }
        });

        if (!_.isEmpty(resultGroup)) {
            _.each(_.chunk(resultGroup, columnCount), function(group) {
                resultItems.push(group);
            });
        }

        return resultItems;
    };

    self.buildRelatedProducts = function(data) {
        var relatedProducts = [];

        if(!_.isEmpty(data)) {
            ko.utils.arrayForEach(data, function(product) {
                relatedProducts.push(new ProductSearchResult(product));

                window.productComments[product.slug] = product.cartComments;
            });
        }

        self.relatedProducts(relatedProducts);
    };

    var doResultsContainCourses = function () {
        var isCourse = false;
        _.forEach(self.items(), function (item) {
            if (item.product.isTrainingCourse && item.product.trainingCourses.length > 0) {
                isCourse = true;
            }
        });

        return isCourse;
    };

    self.getProductListClass = function () {
        var listClass = "";
        if (doResultsContainCourses() === true) {
            listClass = "training-course";
        } else if ($('.product_list').hasClass('list')) {
            listClass = "list";
        }

        return listClass;
    };

    self.afterRender = function () {
        $(document).ready(function () {
            $('.category-product-carousel').on('init', function(){
                $(this).find('.slick-slide .card').height(
                    $(this).find('.slick-track').height()
                );
            });

            initCategoryProductsSlick();
        });
    };

    var sortProductsByYearToDateSales = function (products, numProducts) {
        return _.orderBy(_.slice(products, 0, numProducts), ["product", "product.yearToDateGrossSales"], ["asc", "desc"]);
    };

    self.sortCarouselProducts = function (products) {
        var numProducts = self.productCarouselSettings.options.numProducts;
        if (self.productCarouselSettings.options.carouselDisplayCriteria === "ytdSales") {
            return sortProductsByYearToDateSales(products(), numProducts);
        } else {
            return _.shuffle(_.slice(products(), 0, numProducts));
        }
    };

    self.checkIsGridView = function() {
        return self.isGridView();
    };

    self.setListView = function() {
        self.isGridView(false);
        self.refreshPopover();
    };

    self.setGridView = function() {
        self.isGridView(true);
        self.refreshPopover();
    };

    self.refreshPopover = function() {
        $(".stock-indicator-warehouse-grid-button").popover({
            container: "body",
            html: true,
            content: function() {
                popoverContent = $(this).parent().find(".stock-indicator-warehouse-grid").html();
                return popoverContent;
            }
        });
    };

    self.isGridView(payload.isGridView);
    self.setupDefaultGroupingOption();
    self.setupCurrentGrouping();
    self.buildResults(payload.results);
};

var ProductSearchResult = function(result) {
    var self = this;

    self.score = result.score;
    self.product = new window.catalog.ProductPreview(result);

    self.groupingValue  = function(groupingField) {
        if(groupingField == "category") {
            if(self.product.defaultCategory != undefined) {
                return self.formatGroupingText(self.product.defaultCategory.name);
            }
        } else if(groupingField == "manufacturer") {
            if(self.product.manufacturer != undefined) {
                return self.formatGroupingText(self.product.manufacturer.name);
            }
        } else if(groupingField != "") {
            customField = ko.utils.arrayFirst(self.product.customFields, function(customField) {
                return customField.name == groupingField;
            });

            return customField ? customField.value : "NONE";
        }

        return "NONE";
    };

    self.formatGroupingText = function(value) {
        return value == null || value == "" ? "NONE" : value;
    };

    self.showDetailsInPopup = function() {
        return false;
    };
};

window.Search = window.Search || {};

window.Search.redirectWhenTotalHitsEqualsOne = function (data)
{
    var redirectUrl = "";

    if (!_.isNull(data) && data.totalHits === 1 && _.has(window.SearchApi.globalSettings, "redirectWhenTotalHitsEqualsOne") && window.SearchApi.globalSettings.redirectWhenTotalHitsEqualsOne === "1") {
        redirectUrl = data.items[0].url;
    }

    return redirectUrl;
};

window.Search.checkSearchPhraseRedirect = function (data)
{
    return _.has(data, "searchPhraseRedirectUrl") ? base_index_url + data.searchPhraseRedirectUrl : "";
};

window.Search.performSearchRedirect = function (data)
{
    if (!data.isCategorySearch) {
        var redirectUrl = Search.checkSearchPhraseRedirect(data);

        redirectUrl = _.isEmpty(redirectUrl) ? Search.redirectWhenTotalHitsEqualsOne(data) : redirectUrl;

        if (!_.isEmpty(redirectUrl)) {
            window.location.replace(redirectUrl);
            return true;
        }
    }

    return false;
};

$(function() {
    var form = $("#quick-entry-form");
    var quickEntryCriteria = $("input#quick-entry-criteria");
    var qtyInfo = form.children('div.qty_info');
    var qtyInput = qtyInfo.find('input.qty');
    var uomSelect = qtyInfo.find('select.uom_select');
    var btnAddToCart = qtyInfo.find('button.add_to_cart');
    var quickEntryUoms = $("#quick-entry-uoms");
    var uomsDiv = $("#quick-entry-uoms-template");
    var quickEntryError = $("#quick_entry_error");
    var defaultItem = {value: "", warehouse_id: "", slug: ""};
    var quickEntryAddToCart = $("button#quickEntryAddToCart");

    quickEntryAddToCart.on("click", function (e) {
        e.preventDefault();

        var partNum = quickEntryCriteria.val();
        var dataPartNum = btnAddToCart.attr("data-part-num");
        var item = defaultItem;
        var triggerAddToCart = false;

        if (partNum !== dataPartNum) {
            item.value = quickEntryCriteria.val();
            setAddToCartAttributes(item);

            if (!_.isEmpty(item.value)) {
                triggerAddToCart = true;
            }
        } else if (!_.isEmpty(dataPartNum)) {
            triggerAddToCart = true;
        }

        if (triggerAddToCart) {
            btnAddToCart.trigger("click");
        }
    });

    quickEntryCriteria.autocomplete({
        minLength: 1,
        search: function (event, ui) {
            resetForm();
        },
        source: function (request, response){
            $.post(base_index_url + "quick-entry/" + request.term,
                function (data) {
                    response(data);
                },
                "json"
            );
        },
        response: function (event, ui) {
            if (ui.content.length === 1) {
                var selectedItem = _.first(ui.content);

                $(this).data("ui-autocomplete")._trigger("select", 'autocompleteselect', {item: selectedItem});
                $(this).val(selectedItem.value);
                $(this).autocomplete('close');

                setAddToCartAttributes(selectedItem);
            }
        },
        select: function (event, ui) {
            var selectedItem = ui.item;

            setAddToCartAttributes(selectedItem);
        }
    });

    function resetForm()
    {
        resetAddToCartAttributes();
        hideError();
        quickEntryUoms.html("");
    }

    function resetAddToCartAttributes()
    {
        setAddToCartAttributes(defaultItem);
    }

    function setAddToCartAttributes(item)
    {
        btnAddToCart.attr("data-part-num", item.value);
        btnAddToCart.attr("data-warehouse", item.warehouse_id);
        btnAddToCart.attr("data-slug", item.slug);

        var uomsTemplate = _.template(uomsDiv.html());
        quickEntryUoms.html(uomsTemplate({uoms: item.uoms}));

        if (quickEntryVars.alwaysUseDefaultUom !== 1) {
            quickEntryUoms.show();
        }
    }

    function hideError()
    {
        quickEntryError.html("").addClass("hide");
    }

    function showError(error)
    {
        quickEntryError.html(error).removeClass("hide").slideDown();
    }
});
